import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import {
  Breadcrumb,
  Button,
  CheckPicker,
  Checkbox,
  Col,
  Container,
  Divider,
  Drawer,
  FlexboxGrid,
  IconButton,
  Input,
  InputGroup,
  Panel,
  Stack,
  Modal,
  Loader,
  Dropdown,
  useToaster,
  Message,
  SelectPicker,
  InputPicker,
  Whisper,
  Popover,
  Form,
  InputNumber
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import MenuIcon from '@rsuite/icons/Menu';
import globalIP from '@/GlobelIP';
import { Link } from 'react-router-dom';
import SortUpIcon from '@rsuite/icons/SortUp';
import { useInView } from 'react-intersection-observer';
import TableColumnIcon from '@rsuite/icons/TableColumn';
import EditIcon from '@rsuite/icons/Edit';
import ImportIcon from '@rsuite/icons/Import';
import FormControlLabel from 'rsuite/esm/FormControlLabel';
import TrashIcon from '@rsuite/icons/Trash';
import QrcodeIcon from '@rsuite/icons/Qrcode';
import s1 from './template/QR1.jpg';
import s2 from './template/QR6.jpg';
import s3 from './template/QR7.jpg';
import s4 from './template/QR2.jpg';
import jsPDF from 'jspdf';
import QRCode from 'qrcode-generator';
import LoadingBar from 'react-top-loading-bar';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import useLabel from '@/clientWeb/hook/Label';
import ugr from '@/UGRoute';
import useFilter from '../tables/members/Filters';
import ProductQuickView from '@/components/ProductSearchPage/ProductQuickView';
import { handleDownloadQR4, handleDownloadQR5, handleDownloadQR6, handleDownloadQR7, handleDownloadQR8, handleDownloadQR9 } from '@/components/functions/printQRFunctions';
import ConversionIcon from '@rsuite/icons/Conversion';
import {
  fetchColors,
  fetchFinishes,
  fetchHsn,
  fetchMaterials,
  fetchCategory,
  fetchAlias,
  fetchSkuUnique,
  fetchBuyers,
  fetchMadeBy,
  fetchHeads,
  fetchProductLabel,
  fetchProductDesign,
  fetchProductName,
  fetchSearchKeyword,
  fetchProductTypes
} from '@/apiService/apiService';
import HeaderFilter from '@/components/HeaderFilter';
import FilterDrawer from '@/components/FilterDrawer';
import Footer from '@/components/Footer/Footer';
import ProductCard from '@/components/ProductSearchPage/ProductCard';
import RecyleProduct from './RecyleProduct';
import useUser from '../../components/UseUser';
import Trash from '@rsuite/icons/Trash';
import { Tag } from '@rsuite/icons';
import { DownloadOutlined, DownOutlined, UploadOutlined } from '@ant-design/icons';
import { Button as AntdBtn, Menu, Dropdown as AntdDropdown, Select, Table, Modal as AntdModal, Space, Input as AntDInput } from "antd"
interface RowData {
  id: string; // or number, depending on your data
  attributes: {
    CategoryCode: string;
    ProductTypeCode: string;
    ProductCode: string;
    ProductId: string;
    ProductName: string;
    Description: string;
    SizeUnit: string;
    Length: 0;
    Width: 0;
    Height: 0;
    FinishCode: null;
    ColorCode: null;
    NetWeight: 0;
    GrossWeight: 0;
    HSNCode: string;
    SellingPriceCurrency: string;
    SellingPriceUnit: string;
    SellingPrice: 0;
    ProductCost: 0;
    SearchKeyword: string;
    MOQ: string;
    ProductDesigner: null;
    MadeBy: null;
    CategoryName: string;
    ProductTypeName: null;
    cbm: null;
    FinishName: null;
    ColorName: null;
    BuyerName: null;
    BuyerSku: null;
    SizeRange: null;
    Total_CBM: null;
    Total_CFT: null;
    TwentyFT: null;
    FortyFT: null;
    FortyHQ: null;
    Product_Remark: string;
    Shape: string;
    Season: string;
    P_Technique: string;
    MaterialCollection: [
      {
        ProductCode: string;
        MatCollectionNm: string;
        MatCollectionCode: string;
      }
    ];
    ProductionDetail: [
      {
        ProductCode: string;
        MaterialNm: string;
        MaterialFinishNm: string;
        MatNetWeight: number;
        MaterialCode: string;
        MaterialFinishCode: string;
        Component: string;
        Unit: string;
        Length: number;
        Width: number;
        Height: number;
        Depth: number;
        Qty: number;
        Remark: string;
      }
    ];
  };
}
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
const authstatus = ['Authorised', 'Pending'].map(item => ({ label: item, value: item }));
const ManageProduct = () => {
  const { user } = useUser();
  const ip = globalIP;
  const toaster = useToaster();
  const { attributesName } = useLabel();
  const [selectedImagePath, setSelectedImagePath] = useState('');
  const capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchProductLabel(setLabel);
  }, []);

  const [data123, setData123] = useState([]);
  const [meta123, setMeta123] = useState<MetaData>();
  useEffect(() => { }, [data123]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState([]);
  const [selectedColor, setSelectedColor] = useState([]);
  const [selectedFinish, setSelectedFinish] = useState([]);
  const [selectedBuyer, setSelectedBuyer] = useState([]);
  const [selectedSearch, setSelectedSearch] = useState([]);
  const [selectedAlias, setSelectedAlias] = useState([]);
  const [selectedpron, setSelectedPron] = useState([]);
  const [selectedpd, setSelectedProd] = useState([]);
  const [selectedmade, setSelectedMade] = useState([]);
  const [selectedsku, setSelectedSku] = useState([]);
  const [selectedhsn, setSelectedhsn] = useState([]);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [selectedCategoryCode, setSelectedCategoryCode] = useState([]);
  const [categorydata, setCategorydata] = useState([]);
  const [isLoadingc, setIsLoadingc] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [limit, setLimit] = useState();
  const [progress, setProgress] = useState(0);

  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [selectedUpdatedDateRange, setSelectedUpdatedDateRange] = useState(null);

  const handleDatechange = value => {
    setCurrentPage(1);
    setData123([]);
    setSelectedDateRange(value);
  };
  const handleUpdatedDatechange = value => {
    setCurrentPage(1);
    setData123([]);
    setSelectedUpdatedDateRange(value);
  };

  const { ref, inView } = useInView({
    rootMargin: `0px 0px ${500 + currentPage * 100}px 0px`
  });
  useEffect(() => {
    fetchDatac();
  }, []);
  const fetchDatac = async () => {
    setProgress(30);
    if (isLoadingc) {
      return;
    }
    setIsLoadingc(true);
    try {
      const response = await fetch(
        `${ip}/api/mstcategories?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      setProgress(60);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/mstcategories?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.CategoryName,
          value: item.attributes.CategoryCode
        }));
        allData.push(...processedData);
      }
      setCategorydata(allData);
      setIsLoadingc(false);
      setProgress(100);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  ///////For Product Type//////
  const [productypedata, setProductypedata] = useState([]);
  const [isLoadingpro, setIsLoadingpro] = useState(false);
  useEffect(() => {
    if (selectedCategoryCode) {
      fetchData2();
    }
  }, [selectedCategoryCode, selectedCategory]);
  const fetchData2 = async () => {
    if (isLoadingpro) {
      return;
    }
    setIsLoadingpro(true);
    try {
      const response = await fetch(`${ip}/api/mstproducttypes?&pagination[page]=1`);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(`${ip}/api/mstproducttypes?&pagination[page]=${page}`);
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.ProductTypeName,
          value: item.attributes.ProductTypeCode,
          category: item.attributes.Categorycode   // <-- important
        }));

        allData.push(...processedData);
      }
      setProductypedata(allData);
      setIsLoadingpro(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  // const fetchData2 = async () => {
  //   if (isLoadingpro) {
  //     return;
  //   }
  //   setIsLoadingpro(true);
  //   let categoryFilter = '';
  //   if (selectedCategory.length > 0) {
  //     const categoryFilterString = selectedCategory
  //       .map(cat => `filters[Categorycode][$eq]=${cat}`)
  //       .join('&');
  //     categoryFilter = `&${categoryFilterString}`;
  //   }
  //   try {
  //     const productIdsQueryParam = selectedCategoryCode
  //       .map(id => `filters[Categorycode][$in][]=${id}`)
  //       .join('&');
  //     // Construct the API URL by appending the query parameters
  //     const apiUrl = `${ip}/api/mstproducttypes?${productIdsQueryParam}&populate=*&pagination[page]=1${categoryFilter}`;

  //     const response = await fetch(apiUrl);
  //     const json = await response.json();

  //     const allData = [];
  //     for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
  //       const pageResponse = await fetch(
  //         `${ip}/api/mstproducttypes?${productIdsQueryParam}&populate=*&pagination[page]=${page}${categoryFilter}`
  //       );
  //       const pageJson = await pageResponse.json();
  //       const processedData = pageJson.data.map(item => ({
  //         label: item.attributes.ProductTypeName,
  //         value: item.attributes.ProductTypeCode,
  //         category: item.attributes.Categorycode   // <-- important
  //       }));
  //       allData.push(...processedData);
  //     }
  //     setProductypedata(allData);
  //     setIsLoadingpro(false);
  //   } catch (error) {
  //     console.error('Error fetching category data:', error);
  //   }
  // };

  ///////For Color//////
  const [colordata, setColordata] = useState([]);
  const [isLoadingcolor, setIsLoadingcolor] = useState(false);
  useEffect(() => {
    fetchColors(setColordata, isLoadingcolor, setIsLoadingcolor);
  }, []);

  const [buyernamedata, setBuyerNamedata] = useState([]);
  const [isLoadingbu, setIsLoadingbu] = useState(false);
  useEffect(() => {
    fetchBuyers(setBuyerNamedata, isLoadingbu, setIsLoadingbu);
  }, []);

  const [searchdata, setSearchdata] = useState([]);
  const [isLoadingse, setIsLoadingse] = useState(false);
  useEffect(() => {
    fetchSearchKeyword(setSearchdata, isLoadingse, setIsLoadingse);
  }, []);

  const [proNamedata, setProdNamedata] = useState([]);
  const [isLoadingpron, setIsLoadingpron] = useState(false);
  useEffect(() => {
    fetchProductName(setProdNamedata, isLoadingpron, setIsLoadingpron);
  }, []);

  const [proDdata, setProdDdata] = useState([]);
  const [isLoadingprod, setIsLoadingprod] = useState(false);
  useEffect(() => {
    fetchProductDesign(setProdDdata, isLoadingprod, setIsLoadingprod);
  }, []);

  const [madedata, setMadedata] = useState([]);
  const [isLoadingmade, setIsLoadingmade] = useState(false);
  useEffect(() => {
    fetchMadeBy(setMadedata, isLoadingmade, setIsLoadingmade);
  }, []);

  const [aliasdata, setAliasdata] = useState([]);
  const [isLoadingalias, setIsLoadingalias] = useState(false);
  useEffect(() => {
    fetchAlias(setAliasdata, isLoadingalias, setIsLoadingalias);
  }, []);

  const [skudata, setSkudata] = useState([]);
  const [isLoadingsku, setIsLoadingsku] = useState(false);
  useEffect(() => {
    fetchSkuUnique(setSkudata, isLoadingsku, setIsLoadingsku);
  }, []);

  const [hsndata, setHsndata] = useState([]);
  const [isLoadinghsn, setIsLoadinghsn] = useState(false);
  useEffect(() => {
    fetchHsn(setHsndata, isLoadinghsn, setIsLoadinghsn);
  }, []);

  const [finishdata, setFinishData] = useState([]);
  const [isLoadingfin, setIsLoadingfin] = useState(false);
  useEffect(() => {
    fetchFinishes(setFinishData, isLoadingfin, setIsLoadingfin);
  }, []);

  const [isLoadingTableData, SetIsLoadingTableData] = useState(false);
  const formatDateToISO = date => date.toISOString();

  const getFirstDayOfWeek = date => {
    const firstDay = new Date(date);
    firstDay.setDate(date.getDate() - firstDay.getDay()); // Sunday is the first day of the week
    firstDay.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDay);
  };

  const getFirstDayOfMonth = date => {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    firstDay.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDay);
  };

  const getFirstDayOfLastMonth = date => {
    const firstDayOfLastMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    firstDayOfLastMonth.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDayOfLastMonth);
  };

  const getLastDayOfLastMonth = date => {
    const lastDayOfLastMonth = new Date(date.getFullYear(), date.getMonth(), 0);
    lastDayOfLastMonth.setHours(23, 59, 59, 999);
    return formatDateToISO(lastDayOfLastMonth);
  };

  const getDateDaysAgo = (date, days) => {
    const result = new Date(date);
    result.setDate(date.getDate() - days);
    result.setHours(0, 0, 0, 0);
    return formatDateToISO(result);
  };
  const [authst, setAuthst] = useState('Authorised');
  const [searchQuery, setSearchQuery] = useState('');

  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);

  const fetchData = async (page = 1, append = false) => {
    try {
      if (isLoading) return; // prevent duplicate requests
      setIsLoading(true);
      SetIsLoadingTableData(true);

      // --- FILTERS ---
      const filtersArray = [];

      if (selectedCategory.length > 0) {
        filtersArray.push(
          selectedCategory.map(cat => `filters[CategoryCode][$eq]=${encodeURIComponent(cat)}`).join('&')
        );
      }

      if (selectedProductType.length > 0) {
        filtersArray.push(
          selectedProductType.map(p => `filters[ProductTypeCode][$eq]=${p}`).join('&')
        );
      }

      if (selectedColor.length > 0) {
        filtersArray.push(
          selectedColor.map(c => `filters[ColorCode][$eq]=${c}`).join('&')
        );
      }

      if (selectedFinish.length > 0) {
        filtersArray.push(
          selectedFinish.map(f => `filters[FinishCode][$eq]=${f}`).join('&')
        );
      }

      if (selectedhsn.length > 0) {
        filtersArray.push(
          selectedhsn.map(h => `filters[HSNCode][$eq]=${h}`).join('&')
        );
      }

      if (selectedBuyer.length > 0) {
        filtersArray.push(
          selectedBuyer.map(b => `filters[BuyerName][$eq]=${b}`).join('&')
        );
      }

      if (selectedSearch.length > 0) {
        filtersArray.push(
          selectedSearch.map(s => `filters[SearchKeyword][$eq]=${s}`).join('&')
        );
      }

      if (selectedAlias.length > 0) {
        filtersArray.push(
          selectedAlias.map(a => `filters[ProductId][$eq]=${a}`).join('&')
        );
      }

      if (selectedpron.length > 0) {
        filtersArray.push(
          selectedpron.map(p => `filters[ProductName][$eq]=${p}`).join('&')
        );
      }

      if (selectedpd.length > 0) {
        filtersArray.push(
          selectedpd.map(p => `filters[ProductDesigner][$eq]=${p}`).join('&')
        );
      }

      if (selectedmade.length > 0) {
        filtersArray.push(
          selectedmade.map(m => `filters[MadeBy][$eq]=${m}`).join('&')
        );
      }

      if (selectedsku.length > 0) {
        filtersArray.push(
          selectedsku.map(s => `filters[BuyerSku][$eq]=${s}`).join('&')
        );
      }

      if (authst.length > 0) {
        filtersArray.push(`filters[Authorized][$eq]=${authst}`);
      }

      if (searchQuery.length > 0) {
        const q = searchQuery.trim();
        filtersArray.push(
          `filters[$or][0][ProductId][$containsi]=${q}&filters[$or][1][ProductName][$containsi]=${q}&filters[$or][2][SearchKeyword][$containsi]=${q}`
        );
      }

      // --- DATE FILTERS ---
      const today = new Date();
      const startOfToday = new Date(today.setHours(0, 0, 0, 0));
      const endOfToday = new Date();

      let dateFilter = '';
      switch (selectedDateRange) {
        case 'Today':
          dateFilter = `filters[createdAt][$gte]=${formatDateToISO(startOfToday)}&filters[createdAt][$lte]=${formatDateToISO(endOfToday)}`;
          break;
        case 'Yesterday':
          const yesterday = new Date();
          yesterday.setDate(today.getDate() - 1);
          dateFilter = `filters[createdAt][$eq]=${formatDateToISO(yesterday)}`;
          break;
        case 'This week':
          dateFilter = `filters[createdAt][$gte]=${getFirstDayOfWeek(today)}`;
          break;
        case 'Last week':
          const lastWeekStart = new Date(today);
          lastWeekStart.setDate(today.getDate() - today.getDay() - 7);
          dateFilter = `filters[createdAt][$gte]=${formatDateToISO(lastWeekStart)}&filters[createdAt][$lte]=${getFirstDayOfWeek(today)}`;
          break;
        case 'This month':
          dateFilter = `filters[createdAt][$gte]=${getFirstDayOfMonth(today)}`;
          break;
        case 'Last month':
          dateFilter = `filters[createdAt][$gte]=${getFirstDayOfLastMonth(today)}&filters[createdAt][$lte]=${getLastDayOfLastMonth(today)}`;
          break;
        case 'Last 3 month':
          const threeMonthsAgo = new Date(today);
          threeMonthsAgo.setMonth(today.getMonth() - 3);
          dateFilter = `filters[createdAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
          break;
        case 'Last 6 month':
          const sixMonthsAgo = new Date(today);
          sixMonthsAgo.setMonth(today.getMonth() - 6);
          dateFilter = `filters[createdAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
          break;
        default:
          dateFilter = '';
          break;
      }

      let updatedDateFilter = '';
      switch (selectedUpdatedDateRange) {
        case 'Today':
          updatedDateFilter = `filters[updatedAt][$gte]=${formatDateToISO(startOfToday)}&filters[updatedAt][$lte]=${formatDateToISO(endOfToday)}`;
          break;
        case 'Yesterday':
          updatedDateFilter = `filters[updatedAt][$eq]=${getDateDaysAgo(today, 1)}`;
          break;
        case 'This week':
          updatedDateFilter = `filters[updatedAt][$gte]=${getFirstDayOfWeek(today)}`;
          break;
        case 'Last week':
          const lastWeekStart2 = new Date(today);
          lastWeekStart2.setDate(today.getDate() - today.getDay() - 7);
          updatedDateFilter = `filters[updatedAt][$gte]=${formatDateToISO(lastWeekStart2)}&filters[updatedAt][$lte]=${getFirstDayOfWeek(today)}`;
          break;
        case 'This month':
          updatedDateFilter = `filters[updatedAt][$gte]=${getFirstDayOfMonth(today)}`;
          break;
        case 'Last month':
          updatedDateFilter = `filters[updatedAt][$gte]=${getFirstDayOfLastMonth(today)}&filters[updatedAt][$lte]=${getLastDayOfLastMonth(today)}`;
          break;
        case 'Last 3 month':
          const threeMonthsAgo2 = new Date(today);
          threeMonthsAgo2.setMonth(today.getMonth() - 3);
          updatedDateFilter = `filters[updatedAt][$gte]=${formatDateToISO(threeMonthsAgo2)}`;
          break;
        case 'Last 6 month':
          const sixMonthsAgo2 = new Date(today);
          sixMonthsAgo2.setMonth(today.getMonth() - 6);
          updatedDateFilter = `filters[updatedAt][$gte]=${formatDateToISO(sixMonthsAgo2)}`;
          break;
        default:
          updatedDateFilter = '';
          break;
      }

      if (dateFilter) filtersArray.push(dateFilter);
      if (updatedDateFilter) filtersArray.push(updatedDateFilter);

      // --- BUILD URL ---
      const queryString = filtersArray.filter(Boolean).join('&');
      const url = `${ip}/api/products?populate=*&sort[0]=id:desc&pagination[page]=${page}&${queryString}`;

      // --- FETCH ---
      const response = await fetch(url);
      const json = await response.json();

      setMeta123(json.meta);
      setLimit(json.data.length);

      if (append) {
        setData123(prev => [...prev, ...json.data]);
      } else {
        setData123(json.data);
      }
    } catch (error) {
      console.error('Fetch failed:', error);
    } finally {
      setIsLoading(false);
      SetIsLoadingTableData(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage, currentPage !== 1);
  }, [currentPage, debouncedSearchQuery, selectedCategory, selectedProductType, selectedColor, selectedFinish, selectedhsn, selectedBuyer, selectedAlias, selectedpron, selectedpd, selectedmade, selectedsku, selectedDateRange, selectedUpdatedDateRange, authst]);
  useEffect(() => {
    setSelectedItems([]);
    setIsSelectAllChecked(false);
  }, [debouncedSearchQuery, selectedCategory, selectedProductType, selectedColor, selectedFinish, selectedhsn, selectedBuyer, selectedAlias, selectedpron, selectedpd, selectedmade, selectedsku, selectedDateRange, selectedUpdatedDateRange]);


  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    if (inView && limit) {
      setCurrentPage(prev => prev + 1);
      SetIsLoadingTableData(true);
    }
  }, [inView]);

  const handleFilterChange = (
    filterType,
    value,
    prevValue,
    clearSearchQuery,
    setClearSearchQuery
  ) => {

    const tempsearchq = searchQuery;
    setSearchQuery(''); // Clear the search query first

    const anyOtherFilterSelected =
      selectedCategory.length > 0 ||
      selectedProductType.length > 0 ||
      selectedColor.length > 0 ||
      selectedFinish.length > 0 ||
      selectedhsn.length > 0 ||
      // selectedmaterial.length > 0 ||
      selectedBuyer.length > 0 ||
      selectedSearch.length > 0 ||
      selectedAlias.length > 0 ||
      selectedpron.length > 0 ||
      selectedpd.length > 0 ||
      selectedmade.length > 0 ||
      selectedsku.length > 0;
    // Handle setting clearSearchQuery flag
    if (anyOtherFilterSelected || prevValue.length === 0) {
      setClearSearchQuery(true);
    } else {
      setClearSearchQuery(false);
      setSearchQuery(tempsearchq);
    }

    // Set the filter state for the specific filter type
    switch (filterType) {
      case 'category':
        setSelectedCategory(value);
        break;
      case 'productType':
        setSelectedProductType(value);
        break;
      case 'color':
        setSelectedColor(value);
        break;
      case 'finish':
        setSelectedFinish(value);
        break;
      case 'hsn':
        setSelectedhsn(value);
        break;
      // case 'material':
      //   setSelectedmaterial(value);
      //   break;
      case 'buyer':
        setSelectedBuyer(value);
        break;
      case 'search':
        setSelectedSearch(value);
        break;
      case 'alias':
        setSelectedAlias(value);
        break;
      case 'productName':
        setSelectedPron(value);
        break;
      case 'productDescription':
        setSelectedProd(value);
        break;
      case 'made':
        setSelectedMade(value);
        break;
      case 'sku':
        setSelectedSku(value);
        break;
      default:
        break;
    }

    // Reset pagination
    // setPage(1);
    setCurrentPage(1);

    // Refetch data only after search query is cleared
    // setReload((prev) => !prev);
  };

  // Update individual handlers
  const handleCategoryChange = value => {
    handleFilterChange('category', value, selectedCategory, clearSearchQuery, setClearSearchQuery);
  };
  const handleProductTypeChange = value => {
    handleFilterChange(
      'productType',
      value,
      selectedProductType,
      clearSearchQuery,
      setClearSearchQuery
    );
  };
  const handleColorChange = value => {
    handleFilterChange('color', value, selectedColor, clearSearchQuery, setClearSearchQuery);
  };
  const handleFinishChange = value => {
    handleFilterChange('finish', value, selectedFinish, clearSearchQuery, setClearSearchQuery);
  };
  const handleHSNChange = value => {
    handleFilterChange('hsn', value, selectedhsn, clearSearchQuery, setClearSearchQuery);
  };
  // const handleMaterialChange = (value) => {
  //   handleFilterChange('material', value, selectedmaterial, clearSearchQuery, setClearSearchQuery);
  // };
  const handleBuyerChange = value => {
    handleFilterChange('buyer', value, selectedBuyer, clearSearchQuery, setClearSearchQuery);
  };
  const handleSearchChange = value => {
    handleFilterChange('search', value, selectedSearch, clearSearchQuery, setClearSearchQuery);
  };
  const handleAliasChange = value => {
    handleFilterChange('alias', value, selectedAlias, clearSearchQuery, setClearSearchQuery);
  };
  const handleProNameChange = value => {
    handleFilterChange('productName', value, selectedpron, clearSearchQuery, setClearSearchQuery);
  };
  const handleProDChange = value => {
    handleFilterChange(
      'productDescription',
      value,
      selectedpd,
      clearSearchQuery,
      setClearSearchQuery
    );
  };
  const handleMadeChange = value => {
    handleFilterChange('made', value, selectedmade, clearSearchQuery, setClearSearchQuery);
  };
  const handleSkuChange = value => {
    handleFilterChange('sku', value, selectedsku, clearSearchQuery, setClearSearchQuery);
  };

  /////// For Drawer //////
  const [showDrawer, setShowDrawer] = useState(false);
  const [clearSearchQuery, setClearSearchQuery] = useState(false);
  const [head, setHead] = useState([]);
  useEffect(() => {
    fetchHeads(setHead);
  }, []);
  // useEffect for clearing searchQuery
  useEffect(() => {
    if (clearSearchQuery) {
      fetchData();
    }
  }, [clearSearchQuery]);


  // Debounce effect for searchQuery
  useEffect(() => {
    // setCurrentPage(1);
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // Adjust the debounce delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if searchQuery changes before the delay
  }, [searchQuery]);

  // Effect that triggers on debouncedSearchQuery
  useEffect(() => {
    //  setPage(1);
    fetchData(); // Your data fetching function
    //  TableFetchData();  // Another data fetching function
  }, [debouncedSearchQuery]); // This effect now triggers when debouncedSearchQuery changes
  useEffect(() => {
    setData123([]);
    setMeta123(null);
    setCurrentPage(1); // triggers fetchData automatically
  }, [selectedCategory, selectedProductType, selectedColor, selectedFinish, selectedhsn, selectedBuyer, selectedAlias, selectedpron, selectedpd, selectedmade, selectedsku, selectedDateRange, selectedUpdatedDateRange, authst, debouncedSearchQuery]);

  const [selectedItems, setSelectedItems] = useState([]);
  const handleCheckboxChange = (value, checked) => {
    if (checked) {
      setSelectedItems(prevSelectedItems => [...prevSelectedItems, value]);
    } else {
      setSelectedItems(prevSelectedItems => prevSelectedItems.filter(item => item !== value));
    }
  };
  // const handleCheckAll = (value, checked) => {
  //   if (filtersApplied) {
  //     const filteredProducts = applyFilters();
  //     setSelectedItems(checked ? filteredProducts.map(item => item.id) : []);
  //   } else {
  //     setSelectedItems(checked ? data123.map(item => item.id) : []);
  //   }
  // };
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [totalFilteredCount, setTotalFilteredCount] = useState(0);

  // const handleCheckAll = async (value, checked) => {

  //   // 🟢 CASE 1: Filters applied (Category / ProductType)
  //   if (selectedCategory.length > 0 || selectedProductType.length > 0) {

  //     // 🔍 Apply filters locally instead of refetching
  //     const filtered = data123.filter(item => {
  //       const categoryMatch = selectedCategory.length === 0 ||
  //         selectedCategory.includes(item.attributes.CategoryCode);

  //       const protypeMatch = selectedProductType.length === 0 ||
  //         selectedProductType.includes(item.attributes.ProductTypeCode);

  //       return categoryMatch && protypeMatch;
  //     });

  //     if (checked) {
  //       setSelectedItems(filtered.map(item => item.id));
  //       setTotalFilteredCount(filtered.length);
  //       setIsSelectAllChecked(true);
  //     } else {
  //       setSelectedItems([]);
  //       setIsSelectAllChecked(false);
  //     }

  //     return; // exit early ✔
  //   }

  //   // 🟢 CASE 2: No filters => just select all local data
  //   if (!filtersApplied) {
  //     setSelectedItems(checked ? data123.map(item => item.id) : []);
  //     setIsSelectAllChecked(checked);
  //     return;
  //   }

  //   // 🟢 CASE 3: Other custom filters applied => still use local filtering
  //   const filtered = applyFilters();
  //   setSelectedItems(checked ? filtered.map(item => item.id) : []);
  //   setIsSelectAllChecked(checked);
  // };
  const handleCheckAll = async (param1, param2) => {
    let checked;

    // Case 1: AntD native event → param1.target.checked
    if (param1?.target) {
      checked = param1.target.checked;
    }
    // Case 2: Custom format → (value, checked)
    else {
      checked = param2;
    }

    if (!checked) {
      setSelectedItems([]);
      setIsSelectAllChecked(false);
      return;
    }

    const json = await fetchAllProducts();
    const allIds = json.data.map(item => item.id);

    setSelectedItems(allIds);
    setIsSelectAllChecked(true);
  };

  const fetchAllProducts = async () => {
    const filtersArray = [];

    if (selectedCategory.length > 0) {
      filtersArray.push(
        selectedCategory.map(cat => `filters[CategoryCode][$eq]=${encodeURIComponent(cat)}`).join('&')
      );
    }

    if (selectedProductType.length > 0) {
      filtersArray.push(
        selectedProductType.map(p => `filters[ProductTypeCode][$eq]=${p}`).join('&')
      );
    }

    if (selectedColor.length > 0) {
      filtersArray.push(
        selectedColor.map(c => `filters[ColorCode][$eq]=${c}`).join('&')
      );
    }

    if (selectedFinish.length > 0) {
      filtersArray.push(
        selectedFinish.map(f => `filters[FinishCode][$eq]=${f}`).join('&')
      );
    }

    if (selectedhsn.length > 0) {
      filtersArray.push(
        selectedhsn.map(h => `filters[HSNCode][$eq]=${h}`).join('&')
      );
    }

    if (selectedBuyer.length > 0) {
      filtersArray.push(
        selectedBuyer.map(b => `filters[BuyerName][$eq]=${b}`).join('&')
      );
    }

    if (selectedSearch.length > 0) {
      filtersArray.push(
        selectedSearch.map(s => `filters[SearchKeyword][$eq]=${s}`).join('&')
      );
    }

    if (selectedAlias.length > 0) {
      filtersArray.push(
        selectedAlias.map(a => `filters[ProductId][$eq]=${a}`).join('&')
      );
    }

    if (selectedpron.length > 0) {
      filtersArray.push(
        selectedpron.map(p => `filters[ProductName][$eq]=${p}`).join('&')
      );
    }

    if (selectedpd.length > 0) {
      filtersArray.push(
        selectedpd.map(p => `filters[ProductDesigner][$eq]=${p}`).join('&')
      );
    }

    if (selectedmade.length > 0) {
      filtersArray.push(
        selectedmade.map(m => `filters[MadeBy][$eq]=${m}`).join('&')
      );
    }

    if (selectedsku.length > 0) {
      filtersArray.push(
        selectedsku.map(s => `filters[BuyerSku][$eq]=${s}`).join('&')
      );
    }

    if (authst.length > 0) {
      filtersArray.push(`filters[Authorized][$eq]=${authst}`);
    }

    if (searchQuery.length > 0) {
      const q = searchQuery.trim();
      filtersArray.push(
        `filters[$or][0][ProductId][$containsi]=${q}&filters[$or][1][ProductName][$containsi]=${q}&filters[$or][2][SearchKeyword][$containsi]=${q}`
      );
    }

    // --- DATE FILTERS ---
    const today = new Date();
    const startOfToday = new Date(today.setHours(0, 0, 0, 0));
    const endOfToday = new Date();

    let dateFilter = '';
    switch (selectedDateRange) {
      case 'Today':
        dateFilter = `filters[createdAt][$gte]=${formatDateToISO(startOfToday)}&filters[createdAt][$lte]=${formatDateToISO(endOfToday)}`;
        break;
      case 'Yesterday':
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        dateFilter = `filters[createdAt][$eq]=${formatDateToISO(yesterday)}`;
        break;
      case 'This week':
        dateFilter = `filters[createdAt][$gte]=${getFirstDayOfWeek(today)}`;
        break;
      case 'Last week':
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - today.getDay() - 7);
        dateFilter = `filters[createdAt][$gte]=${formatDateToISO(lastWeekStart)}&filters[createdAt][$lte]=${getFirstDayOfWeek(today)}`;
        break;
      case 'This month':
        dateFilter = `filters[createdAt][$gte]=${getFirstDayOfMonth(today)}`;
        break;
      case 'Last month':
        dateFilter = `filters[createdAt][$gte]=${getFirstDayOfLastMonth(today)}&filters[createdAt][$lte]=${getLastDayOfLastMonth(today)}`;
        break;
      case 'Last 3 month':
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(today.getMonth() - 3);
        dateFilter = `filters[createdAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
        break;
      case 'Last 6 month':
        const sixMonthsAgo = new Date(today);
        sixMonthsAgo.setMonth(today.getMonth() - 6);
        dateFilter = `filters[createdAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
        break;
      default:
        dateFilter = '';
        break;
    }

    let updatedDateFilter = '';
    switch (selectedUpdatedDateRange) {
      case 'Today':
        updatedDateFilter = `filters[updatedAt][$gte]=${formatDateToISO(startOfToday)}&filters[updatedAt][$lte]=${formatDateToISO(endOfToday)}`;
        break;
      case 'Yesterday':
        updatedDateFilter = `filters[updatedAt][$eq]=${getDateDaysAgo(today, 1)}`;
        break;
      case 'This week':
        updatedDateFilter = `filters[updatedAt][$gte]=${getFirstDayOfWeek(today)}`;
        break;
      case 'Last week':
        const lastWeekStart2 = new Date(today);
        lastWeekStart2.setDate(today.getDate() - today.getDay() - 7);
        updatedDateFilter = `filters[updatedAt][$gte]=${formatDateToISO(lastWeekStart2)}&filters[updatedAt][$lte]=${getFirstDayOfWeek(today)}`;
        break;
      case 'This month':
        updatedDateFilter = `filters[updatedAt][$gte]=${getFirstDayOfMonth(today)}`;
        break;
      case 'Last month':
        updatedDateFilter = `filters[updatedAt][$gte]=${getFirstDayOfLastMonth(today)}&filters[updatedAt][$lte]=${getLastDayOfLastMonth(today)}`;
        break;
      case 'Last 3 month':
        const threeMonthsAgo2 = new Date(today);
        threeMonthsAgo2.setMonth(today.getMonth() - 3);
        updatedDateFilter = `filters[updatedAt][$gte]=${formatDateToISO(threeMonthsAgo2)}`;
        break;
      case 'Last 6 month':
        const sixMonthsAgo2 = new Date(today);
        sixMonthsAgo2.setMonth(today.getMonth() - 6);
        updatedDateFilter = `filters[updatedAt][$gte]=${formatDateToISO(sixMonthsAgo2)}`;
        break;
      default:
        updatedDateFilter = '';
        break;
    }

    if (dateFilter) filtersArray.push(dateFilter);
    if (updatedDateFilter) filtersArray.push(updatedDateFilter);

    // --- BUILD URL ---
    const queryString = filtersArray.filter(Boolean).join('&');
    // Fetch all
    const allUrl = `${ip}/api/products?populate=*&sort[0]=id:desc&pagination[page]=1&pagination[pageSize]=100000&${queryString}`;
    const res = await fetch(allUrl);
    const json = await res.json();
    return json
  }
  const applyFilters = () => {
    let filteredProducts = data123;
    if (selectedCategory.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedCategory.includes(item.attributes.CategoryCode)
      );
    }
    if (selectedProductType.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedProductType.includes(item.attributes.ProductTypeCode)
      );
    }
    if (selectedColor.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedColor.includes(item.attributes.ColorCode)
      );
    }
    if (selectedFinish.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedFinish.includes(item.attributes.FinishCode)
      );
    }
    if (selectedhsn.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedhsn.includes(item.attributes.HSNCode)
      );
    }
    return filteredProducts;
  };
  const [isCartOpen, setIsCartOpen] = useState(false);
  const handleCartClose = () => {
    setIsCartOpen(false);
  };
  const [open, setOpen] = useState(false);
  const [size, setSize] = useState();
  const [data11, setData11] = useState([]);
  const [modeldata, setmodeldata] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState('inch');
  const handleOpen = (value, prdcd) => {
    setSize(value);
    setOpen(true);
    setId(prdcd);
    const newArray = [...data123];
    const filteredData = newArray.filter(item => item.id === prdcd);
    setmodeldata(filteredData);
    if (filteredData[0].attributes.SetStatus === 'Set') {
      setData11(filteredData[0].attributes.SetSizes);
    } else {
      const data = [
        {
          Length: filteredData[0].attributes.Length,
          Width: filteredData[0].attributes.Width,
          Height: filteredData[0].attributes.Height,
          SizeUnit: filteredData[0].attributes.SizeUnit
        }
      ];
      setData11(data);
    }
  };

  const unitOptions = [
    { label: 'Inch', value: 'inch' },
    { label: 'CM', value: 'cm' }
  ];
  // const handleSizeChange = value => {
  //   // setSizeUnit(newSizeUnit);
  //   setSelectedUnit(value);
  //   const convertedData = convertDimensions(data11, value);
  //   setData11(convertedData);
  // };
  const handleSizeChange = value => {
    setSelectedUnit(value);
    const convertedData = convertDimensions(data11, value);
    setData11(convertedData);
  };
  const convertDimensions = (data, selectedUnit) => {
    const conversionFactor = selectedUnit === 'inch' ? 0.393701 : 2.54;

    return data.map(item => {
      // Skip conversion if the SizeUnit matches the selectedUnit
      if (item.SizeUnit === selectedUnit) {
        return item;
      }

      // Convert dimensions if SizeUnit does not match the selectedUnit
      let convertedItem = {
        ...item,
        Length: (item.Length || 0) * conversionFactor,
        Width: (item.Width || 0) * conversionFactor,
        Height: (item.Height || 0) * conversionFactor,
        SizeUnit: selectedUnit
      };

      return convertedItem;
    });
  };

  // const convertDimensions = (data, selectedUnit) => {
  //   const conversionFactor = selectedUnit === 'inch' ? 0.393701 : 2.54;

  //   return data.map(item => {
  //     let convertedItem = {
  //       ...item,
  //       Length: (item.Length || 0) * conversionFactor,
  //       Width: (item.Width || 0) * conversionFactor,
  //       Height: (item.Height || 0) * conversionFactor,
  //       SizeUnit: selectedUnit,
  //     };

  //     // If the selected unit is cm, round to one decimal place
  //     if (selectedUnit === 'cm') {
  //       convertedItem.Length = parseFloat(convertedItem.Length.toFixed(1));
  //       convertedItem.Width = parseFloat(convertedItem.Width.toFixed(1));
  //       convertedItem.Height = parseFloat(convertedItem.Height.toFixed(1));
  //     }

  //     // If the selected unit is inch, round to the nearest whole number
  //     if (selectedUnit === 'inch') {
  //       convertedItem.Length = Math.round(convertedItem.Length);
  //       convertedItem.Width = Math.round(convertedItem.Width);
  //       convertedItem.Height = Math.round(convertedItem.Height);
  //     }
  //     return convertedItem;
  //   });
  // };
  const handleClose = () => setOpen(false);
  const [imageList, setImageList] = useState([]);
  const [id, setId] = useState();
  useEffect(() => {
    if (id) {
      fetchData1234();
    }
  }, [id]);
  const fetchData1234 = async () => {
    const response = await fetch(`${ip}/api/products?populate=*&filters[id][$eq]=${id}`);
    const json = await response.json();
    // Concatenate data from all pages into a single array
    const extractedImageList = json.data
      .filter(item => item.attributes.MultipleImage && item.attributes.MultipleImage.data)
      .map(item => item.attributes.MultipleImage.data.map(image => image.attributes.url))
      .flat(); // Flatten the array of arrays
    const coverImage = json.data.map(item => item.attributes.CoverImage.data.attributes.url);
    extractedImageList.unshift(coverImage);
    const prefixed_list = extractedImageList.map(file => ip + file);
    setImageList(prefixed_list);
  };
  const defaultImageIndex = 0; // Index of the default image
  const [selectedImageIndex, setSelectedImageIndex] = useState(defaultImageIndex); // Initial selected image index

  const handleNextImage = item => {
    const totalImages = item?.attributes?.MultipleImage?.data?.length + 1; // Add 1 for the CoverImage
    setSelectedImageIndex(prevIndex => (prevIndex + 1) % totalImages);
  };

  const handlePrevImage = item => {
    const totalImages = item?.attributes?.MultipleImage?.data?.length + 1; // Add 1 for the CoverImage
    setSelectedImageIndex(prevIndex => (prevIndex - 1 + totalImages) % totalImages);
  };

  useEffect(() => {
    const item = modeldata[0]; // Assuming you want the first item in the array

    if (!item) {
      console.error('Item is undefined');
      return;
    }

    if (selectedImageIndex === 0) {
      // When selected index is 0, set the CoverImage
      const coverImageUrl = item?.attributes?.CoverImage?.data?.attributes?.url;
      if (coverImageUrl) {
        setSelectedImagePath({
          url: coverImageUrl,
          id: item.id,
          default: true
        });
      } else {
        console.error('Cover image not found');
      }
    } else {
      // Otherwise, set the corresponding MultipleImage
      const imageIndex = selectedImageIndex - 1; // Subtract 1 because CoverImage is index 0
      const selectedImage = item?.attributes?.MultipleImage?.data?.[imageIndex];
      if (selectedImage && selectedImage?.attributes?.url) {
        setSelectedImagePath({
          url: selectedImage?.attributes?.url,
          id: item.id,
          default: true
        });
      } else {
        console.error('Multiple image not found at index', imageIndex);
      }
    }
  }, [selectedImageIndex, modeldata]);

  const [sizeshow, setSizeShow] = useState(false);
  const [auth, setAuth] = useState(false);

  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      setAuth(json.data[0].attributes.Authorised);
      setSizeShow(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [opendelete, setOpendelete] = useState(false);
  const handleOpendelete = () => {
    if (selectedItems.length === 0) {
      toaster.push(
        <Message showIcon type="error">
          Please Select Products
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      setOpendelete(true);
    }
  };
  const [deltask, setDeltask] = useState(0);
  const handleClosedelete = () => setOpendelete(false);
  const [loadelete, setLoadelete] = useState(false);

  const [data, setData] = useState([]);
  const [isLoadingt, setIsLoadingt] = useState(false);
  const [tableMeta, setTableMeta] = useState([]);
  const [page, setPage] = useState(1);
  const [searchQuery1, setSearchQuery1] = useState('');
  const [debouncedSearchQuery1, setDebouncedSearchQuery1] = useState(searchQuery1);

  useEffect(() => {
    setPage(1);
    const timer = setTimeout(() => {
      setDebouncedSearchQuery1(searchQuery1);
    }, 200);

    return () => clearTimeout(timer);
  }, [searchQuery1]);
  useEffect(() => {
    setPage(1);
    fetchDatat();
  }, [debouncedSearchQuery1]);
  const handleChangeLimit = () => {
    setPage(1);
  };
  useEffect(() => {
    fetchDatat();
  }, [page]);
  const fetchDatat = async () => {
    if (isLoadingt) {
      return;
    }
    setIsLoadingt(true);
    let searchQryFilter = '';
    if (searchQuery1.length > 0) {
      let searchQryy = searchQuery1.trim();
      const searchQry = `filters[$or][0][ProductName][$containsi]=${searchQryy}&filters[$or][1][ProductId][$containsi]=${searchQryy}&filters[$or][2][CategoryName][$containsi]=${searchQryy}`;
      searchQryFilter = `&${searchQry}`;
    }
    const response = await fetch(
      `${globalIP}/api/products?populate=*&pagination[page]=${page}&filters[Authorized][$eq]=Inactive${searchQryFilter}`
    );
    const json = await response.json();
    setData(json.data);
    setTableMeta(json.meta);
    setIsLoadingt(false);
  };

  const deleteProduct = async () => {
    try {
      setDeltask(selectedItems.length);
      setLoadelete(true);

      for (const ProductId of selectedItems) {
        // Fetch the main product details to get the ProductCode
        const mainProductResponse = await fetch(`${ip}/api/products/${ProductId}`);
        if (!mainProductResponse.ok) {
          console.error(`Failed to fetch main product with ID ${ProductId}.`);
          continue;
        }

        const mainProductData = await mainProductResponse.json();
        const productCode = mainProductData?.data?.attributes?.ProductCode;

        if (!productCode) {
          console.error(`ProductCode not found for main product ID ${ProductId}.`);
          continue;
        }

        // ✅ Update the main product to set Authorized = "Inactive"
        const mainProductUpdateResponse = await fetch(`${ip}/api/products/${ProductId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              Authorized: 'Inactive'
            }
          })
        });

        if (mainProductUpdateResponse.ok) {
        } else {
          console.error(`Failed to update main product with ID ${ProductId}.`);
        }

        // Fetch variant products associated with the ProductCode
        const variantResponse = await fetch(`${ip}/api/variant-products`);
        if (!variantResponse.ok) {
          console.error('Failed to fetch variant products.');
          continue;
        }

        const variantData = await variantResponse.json();
        const variantsToUpdate = variantData?.data?.filter(
          variant => variant.attributes.Variant_Id === productCode
        );

        // ✅ Update variant products to set Authorized = "Inactive"
        for (const variant of variantsToUpdate) {
          const variantId = variant.id;

          const variantUpdateResponse = await fetch(`${ip}/api/variant-products/${variantId}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              data: {
                Authorized: 'Inactive'
              }
            })
          });

          if (variantUpdateResponse.ok) {
          } else {
            console.error(`Failed to update variant product with ID ${variantId}.`);
          }
        }
      }
      setLoadelete(false);
      fetchData();
      setSelectedItems([]);
      handleClosedelete();
      setIsRobotChecked2(false);
      fetchDatat();
      toaster.push(
        <Message showIcon type="success">
          {selectedItems.length} Products Deleted Successfully.
        </Message>,
        { placement: 'topEnd' }
      );
    } catch (error) {
      console.error('Error deleting products and variants:', error);
      setLoadelete(false);
    }
  };

  const [openm, setOpenm] = useState(false);
  const handleOpenm = () => setOpenm(true);
  const handleClosem = () => {
    setIsRobotChecked(false);
    setOpenm(false);
  };
  const [selectedCategorychange, setSelectedCategorychange] = useState(null);
  const [selectedProductchange, setSelectedProductchange] = useState(null);
  const [isLoadingupdate, setIsLoadingupdate] = useState(false);
  const [catetask, setCatetask] = useState(0);
  const [updatetask, setUpdatetask] = useState(0);
  const updatecategoryProduct = async () => {
    try {
      if (selectedItems.length === 0) {
        toaster.push(
          <Message showIcon type="error">
            Please Select Products
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        setIsLoadingupdate(true);
        setCatetask(selectedItems.length);
        for (const ProductId of selectedItems) {
          const formData = new FormData();
          formData.append(
            'data',
            JSON.stringify({
              CategoryName: selectedCategorychange.label,
              CategoryCode: selectedCategorychange.value,
              ProductTypeName: selectedProductchange.label,
              ProductTypeCode: selectedProductchange.value
            })
          );
          const response = await fetch(`${ip}/api/products/${ProductId}`, {
            method: 'PUT',
            body: formData
          });
          if (response.ok) {
            // If the deletion is successful, log the result or perform any necessary actions
          } else {
            console.error(`Failed to Update fair product with ID ${ProductId}.`);
          }
        }
        setIsLoadingupdate(false);
        fetchData();
        setSelectedItems([]);
        handleClosem();
        toaster.push(
          <Message showIcon type="success">
            {selectedItems.length} Products Update Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
        setIsRobotChecked(false);
      }
    } catch (error) {
      console.error('Error Updateing fair products:', error);
    }
  };
  const [isRobotChecked, setIsRobotChecked] = useState(false);
  const [isRobotChecked1, setIsRobotChecked1] = useState(false);
  const [isRobotChecked2, setIsRobotChecked2] = useState(false);

  const [opene, setOpene] = useState(false);
  const handleOpene = () => setOpene(true);
  const handleClosee = () => {
    setOpene(false);
  };
  const handleCloseecondition = () => {
    setOpene(false);
    setOpenn(true);
  };
  const [finShow, setFinShow] = useState(false);
  const [data1, setData1] = useState([]);
  useEffect(() => {
    fetchDatacd();
  }, []);
  const fetchDatacd = async () => {
    const response = await fetch(`${globalIP}/api/company-details?populate=*`);
    const json = await response.json();
    setFinShow(json.data[0].attributes.setFinish);
    setData1(json.data);
  };
  const [openq, setOpenq] = useState(false);

  const loadImageDimensions = url => {
    return new Promise(resolve => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.src = url;
    });
  };

  const handleDownloadPDF = async (productData, printOrNot) => {
    const pdf = new jsPDF();
    const logoUrl = data1.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
    const img = `${globalIP}${logoUrl}`;
    const boxWidth = 99;
    const boxHeight = 56;
    const boxesPerRow = 2;
    const maxBoxesPerPage = 10;

    if (productData.length === 0) {
      alert('No rows selected for export QR Code2!');
      return;
    }

    for (const [index, product] of productData.entries()) {
      if (index % maxBoxesPerPage === 0 && index !== 0) {
        pdf.addPage();
      }

      const relativeIndex = index % maxBoxesPerPage;
      const row = Math.floor(relativeIndex / boxesPerRow);
      const col = relativeIndex % boxesPerRow;
      const boxX = 2 + col * (boxWidth + 2);
      const boxY = 3 + row * (boxHeight + 3);
      pdf.rect(boxX, boxY, boxWidth, boxHeight);

      const img1 = product.image;
      const imgp = `${globalIP}${img1}`;
      const productImageDimensions = await loadImageDimensions(imgp);

      // Define max dimensions for the image within the container
      const maxImageWidth = 30; // Adjust to fit the container
      const maxImageHeight = 30;

      // Scale the image proportionally
      let productImageWidth = productImageDimensions.width;
      let productImageHeight = productImageDimensions.height;

      const widthRatio = maxImageWidth / productImageWidth;
      const heightRatio = maxImageHeight / productImageHeight;
      const scaleRatio = Math.min(widthRatio, heightRatio);

      if (scaleRatio < 1) {
        productImageWidth *= scaleRatio;
        productImageHeight *= scaleRatio;
      }

      // Center the image within the container
      const centeredX = 55 + boxX + (maxImageWidth - productImageWidth) / 2;
      const centeredY = 7 + boxY + (maxImageHeight - productImageHeight) / 2;

      pdf.addImage(imgp, 'JPEG', centeredX, centeredY, productImageWidth, productImageHeight);

      // Add the logo with similar scaling and positioning logic
      const logoDimensions = await loadImageDimensions(img);
      const maxLogoWidth = 22;
      const maxLogoHeight = 7;

      let logoWidth = logoDimensions.width;
      let logoHeight = logoDimensions.height;

      const logoWidthRatio = maxLogoWidth / logoWidth;
      const logoHeightRatio = maxLogoHeight / logoHeight;
      const logoScaleRatio = Math.min(logoWidthRatio, logoHeightRatio);

      if (logoScaleRatio < 1) {
        logoWidth *= logoScaleRatio;
        logoHeight *= logoScaleRatio;
      }

      const logoX = 6 + boxX + (maxLogoWidth - logoWidth) / 2;
      const logoY = 1 + boxY + (maxLogoHeight - logoHeight) / 2;

      pdf.addImage(img, 'JPEG', logoX, logoY, logoWidth, logoHeight);

      // Add the remaining content (text, QR code, etc.)
      pdf.setFont('sans-serif', 'bold');
      pdf.setFontSize(8);
      pdf.text('Tag Code :', 6 + boxX, 44 + boxY);
      pdf.text('Name :', 6 + boxX, 48 + boxY);
      pdf.setFont('sans-serif', 'normal');
      pdf.setFontSize(8);
      pdf.text(`${product.code}`, 22 + boxX, 44 + boxY);
      pdf.text(`${product.name}`, 16 + boxX, 48 + boxY);

      const qrCode = QRCode(0, 'L');
      qrCode.addData(product.pcode);
      qrCode.make();
      const qrCodeImage = qrCode.createDataURL();
      const qrCodeWidth = 38;
      const qrCodeHeight = 35;
      pdf.addImage(qrCodeImage, 'JPEG', 2 + boxX, boxY + 5.7, qrCodeWidth, qrCodeHeight);

      pdf.setFont('sans-serif', 'bold');
      pdf.setFontSize(8);
      pdf.text('Grs Wt :', 55 + boxX, 44 + boxY);
      pdf.text('Net Wt :', 74 + boxX, 44 + boxY);
      pdf.setFont('sans-serif', 'normal');
      pdf.setFontSize(8);
      pdf.text(`${product.grwt}`, 67 + boxX, 44 + boxY);
      pdf.text(`${product.ntwt}`, 86 + boxX, 44 + boxY);

      pdf.setFont('sans-serif', 'italic', 'bold');
      pdf.text('Powered By :', 6 + boxX, 53 + boxY);
      pdf.setTextColor(24, 61, 104);
      pdf.setFontSize(8);
      pdf.text('ERPDaddy Software Solution(P) Ltd.', 23 + boxX, 53 + boxY);
      pdf.setTextColor(0, 0, 0);
    }

    if (printOrNot === 'Print') {
      pdf.output('dataurlnewwindow');
    } else {
      pdf.save('QRPrint.pdf');
    }
  };
  const handleDownloadPDF2 = productData => {
    const pdf = new jsPDF();
    const logoUrl = data1.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
    const img = `${globalIP}${logoUrl}`;
    const boxWidth = 51;
    const boxHeight = 60;
    const boxesPerRow = 4; // Number of boxes per row
    const maxBoxesPerPage = 20;
    // Iterate over each product in productData
    productData.forEach((product, index) => {
      if (index % maxBoxesPerPage === 0 && index !== 0) {
        // Add a new page if the maximum number of boxes per page is reached
        pdf.addPage();
      }
      const relativeIndex = index % maxBoxesPerPage;
      const row = Math.floor(relativeIndex / boxesPerRow);
      const col = relativeIndex % boxesPerRow;
      // Calculate the starting point of each box based on row and column
      const boxX = 1 + col * (boxWidth + 1); // 5 is the horizontal margin between boxes
      const boxY = 1 + row * (boxHeight + 1); // 5 is the vertical margin between boxes
      // Draw a box for each product
      pdf.rect(boxX, boxY, boxWidth, boxHeight);
      // Define the box properties for the logo within each box
      const logoWidth = 25; // Adjust the logo width as needed
      const logoHeight = 7; // Adjust the logo height as needed
      const logoX = 12.5 + boxX; // Adjust the X position as needed
      const logoY = 2 + boxY; // Adjust the Y position as needed
      // Add the logo to the PDF within each box
      pdf.addImage(img, 'JPEG', logoX, logoY, logoWidth, logoHeight);

      const qrCode = QRCode(0, 'L');
      qrCode.addData(product.pcode);
      qrCode.make();
      const qrCodeImage = qrCode.createDataURL();
      const qrCodeWidth = 40;
      const qrCodeHeight = 40;
      pdf.addImage(qrCodeImage, 'JPEG', 5.5 + boxX, boxY + 9, qrCodeWidth, qrCodeHeight);
      pdf.setFontSize(10);
      // Add product-specific information within each box
      pdf.text(`Code : ${product.code}`, 15.5 + boxX, 48 + boxY);
      pdf.text('Powered By', 15.5 + boxX, 53 + boxY);
      pdf.setTextColor(46, 120, 204);
      // Add text with color and style within each box
      pdf.setFontSize(8);
      pdf.text('ERPDADDY Software Solution(p) Ltd.', 2 + boxX, 58 + boxY);
      pdf.setTextColor(0, 0, 0);
    });
    // Save the PDF as a file with the name 'example.pdf'
    pdf.save('QRPrint.pdf');
  };

  const [fairname, setFairname] = useState([]);
  useEffect(() => {
    fetchDataFair();
  }, []);
  const fetchDataFair = async () => {
    const response = await fetch(
      `${globalIP}/api/fair-masters?populate=*&filters[fairstatus][$eq]=Active`
    );
    const json = await response.json();
    const processedData = json.data.map(item => ({
      label: item.attributes.fairName,
      value: item.attributes.fairCode
    }));
    setFairname(processedData);
  };

  const fairmaster = `${globalIP}/api/fair-product-masters`;
  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => {
    // fetchDataBasedOnAction();
    setOpen2(false);
    window.location.reload();
  };
  const submitwithqr = async () => {
    for (const selectedProduct of selectedItems) {
      const selectedProductData = data123.find(product => product.id === selectedProduct);
      if (selectedProductData) {
        const formData = new FormData();
        formData.append(
          'data',
          JSON.stringify({
            faircode: fairname.length > 0 ? fairname[0].value : '',
            fairname: fairname.length > 0 ? fairname[0].label : '',
            prdcd: selectedProductData.attributes.ProductCode,
            aliascd: selectedProductData.attributes.ProductId,
            minCost: 0,
            avgCost: 0,
            maxCost: 0,
            currency: 'USD'
            // ... other properties
          })
        );
        // Use the product-specific API endpoint for creating a fair-product
        const response = await fetch(fairmaster, {
          method: 'POST',
          body: formData
        });
        // Handle the response as needed
        const data = await response.json();
      }
    }
    setIsLoading(false);
    handleOpen2();
    setOpenq(false);
  };
  const [maindata, setMainData] = useState([]);
  const [maindataexcel, setMainDataExcel] = useState([]);
  const fetchDataforQR = () => {
    // Filter selected items from local data123
    const selectedData = data123.filter(item =>
      selectedItems.includes(item.id)
    );

    // Format QR data
    const productData = selectedData.map(item => ({
      code: item?.attributes?.ProductId ?? '',
      name: item?.attributes?.ProductName ?? '',
      size: `${item?.attributes?.Length ?? ''}x${item?.attributes?.Width ?? ''}x${item?.attributes?.Height ?? ''} ${item?.attributes?.SizeUnit ?? ''}`,
      pcode: item?.attributes?.ProductCode ?? '',
      image: item?.attributes?.CoverImage?.data?.attributes?.url ?? '',
      grwt: item?.attributes?.GrossWeight ?? '',
      ntwt: item?.attributes?.NetWeight ?? '',
      material: item?.attributes?.ProductionDetail
        ?.map(d => d.MaterialCode)
        .join(', ') ?? '',
      finish: item?.attributes?.FinishName ?? ''
    }));
    setMainData(productData);

    // For Excel export use raw selected data
    setMainDataExcel(selectedData);
  };
  useEffect(() => {
    if (selectedItems.length) {
      fetchDataforQR();
    }
  }, [selectedItems]);

  const [openn, setOpenn] = useState(false);
  const handleOpenn = () => setOpenn(true);
  const handleClosen = () => {
    setIsRobotChecked1(false);
    setOpenn(false);
  };
  //////// Edit Attributes /////////
  const [siii, setSiii] = useState([
    { label: 'CM', value: 'cm' },
    { label: 'Inch', value: 'inch' }
  ]);
  const [category, setCategory] = useState(false);
  const [Productype, setProductype] = useState(false);
  const [moq, setMoq] = useState(false);
  const [description, setDescription] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState(false);
  const [color, setColor] = useState(false);
  const [productname, setProductname] = useState(false);
  const [finish, setFinish] = useState(false);
  const [netWeight, setNetWeight] = useState(false);
  const [grossweight, setGrossweight] = useState(false);
  const [hsn, setHsn] = useState(false);
  const [productDesigner, setProductDesigner] = useState(false);
  const [madeby, setMadeby] = useState(false);
  const [buyername, setBuyername] = useState(false);
  const [buyersku, setBuyersku] = useState(false);
  const [sizeupdate, setSizeUpdate] = useState(false);
  const [shape, setShape] = useState(false);
  const [season, setSeason] = useState(false);
  const [ptech, setPtech] = useState(false);
  const [coll, setColl] = useState(false);
  const [mat, setMat] = useState(false);
  const [sizeRange, setSizeRange] = useState(false);
  const [atLeastOneChecked, setAtLeastOneChecked] = useState(false);

  const handlecategoryCheckbox = () => {
    setCategory(!category);
    setProductype(!Productype);
  };
  const handlesubCategoryCheckbox = () => {
    setCategory(!category);
    setProductype(!Productype);
  };
  const handlemoqCheckbox = () => {
    setMoq(!moq);
  };
  const handledescriptionCheckbox = () => {
    setDescription(!description);
  };
  const handlesearchKeywordCheckbox = () => {
    setSearchKeyword(!searchKeyword);
  };
  const handleproductionTimeCheckbox = () => {
    setProductname(!productname);
  };
  const handleremarksCheckbox = () => {
    setFinish(!finish);
  };
  const handlesamplingTimeCheckbox = () => {
    setNetWeight(!netWeight);
  };
  const handleproductionTechCheckbox = () => {
    setGrossweight(!grossweight);
  };
  const handlepriceFromeVendorCheckbox = () => {
    setHsn(!hsn);
  };
  const handlecolorCheckbox = () => {
    setColor(!color);
  };
  const handleexclusiveForCheckbox = () => {
    setProductDesigner(!productDesigner);
  };
  const handleshapeCheckbox = () => {
    setMadeby(!madeby);
  };
  const handlevendornameCheckbox = () => {
    setBuyername(!buyername);
  };
  const handlethemeCheckbox = () => {
    setBuyersku(!buyersku);
  };
  const handlesizeCheckbox = () => {
    setSizeUpdate(!sizeupdate);
  };
  const handleShapeCheckbox = () => {
    setShape(!shape);
  };
  const handleSeasonCheckbox = () => {
    setSeason(!season);
  };
  const handlePtechCheckbox = () => {
    setPtech(!ptech);
  };
  const handleSrangeCheckbox = () => {
    setSizeRange(!sizeRange);
  };
  const handleCollectionCheckbox = () => {
    setColl(!coll);
  };
  const handleCollectionMaterials = () => {
    setMat(!mat);
  };
  const [editedData, setEditedData] = useState<Record<string, Partial<RowData['attributes']>>>({});
  const [result, setResult] = useState(0);
  const [costinghead, setCostingHead] = useState({
    L: 0,
    M: 0,
    X: 0
  });
  const [data5, setData5] = useState({
    CategoryCode: '',
    ProductTypeCode: '',
    ProductCode: '',
    ProductId: '',
    ProductName: '',
    Description: '',
    SizeUnit: 'inch',
    Length: 0,
    Width: 0,
    Height: 0,
    FinishCode: '',
    ColorCode: '',
    NetWeight: 0,
    GrossWeight: 0,
    HSNCode: '',
    SellingPriceCurrency: '',
    SellingPriceUnit: '',
    SellingPrice: 0,
    ProductCost: 0,
    SearchKeyword: '',
    MOQ: 0,
    ProductDesigner: '',
    MadeBy: '',
    CategoryName: '',
    ProductTypeName: '',
    cbm: 0,
    Shape: '',
    Season: '',
    P_Technique: '',
    FinishName: '',
    ColorName: '',
    BuyerName: '',
    BuyerSku: '',
    SizeRange: '',
    Product_Remark: '',
    Buyer_Remark: '',
    Variant: 'false',
    SetStatus: 'Single',
    Part: '1',
    Authorized: '',
    L: 0,
    M: 0,
    MX: 0,
    MaterialCollection: [
      {
        ProductCode: '',
        MatCollectionNm: '',
        MatCollectionCode: ''
      }
    ],
    ProductionDetail: [
      {
        ProductCode: '',
        MaterialNm: '',
        MaterialFinishNm: '',
        MatNetWeight: 0,
        MaterialCode: '',
        MaterialFinishCode: '',
        Component: '',
        Unit: 'inch',
        Length: 0,
        Width: 0,
        Height: 0,
        Depth: 0,
        Qty: 0,
        Remark: ''
      }
    ],
    CoverImage: null,
    MultipleImage: null,
    threeDview: null,
    Total_CBM: 0,
    Total_CFT: 0,
    TwentyFT: '',
    FortyFT: '',
    FortyHQ: '',
    Packaging: [
      {
        CartonType: 'master',
        ProductCode: '',
        Carton_Unit: 'inch',
        Carton_Length: 0,
        Carton_Width: 0,
        Carton_Thick: 0,
        Carton_CBM: 0,
        Carton_PCS: 1,
        Carton_CBMperpc: 0,
        Carton_GrsWt: 0
      }
    ],
    SetSizes: [
      {
        SizeUnit: 'inch',
        SetRate: 0,
        Length: 0,
        Width: 0,
        Height: 0,
        cbm: 0,
        Description: '',
        ColorName: '',
        ColorCode: '',
        FinishName: '',
        FinishCode: '',
        NetWt: 0,
        MatName: ''
      }
    ]
  })
  const handleInputChange = (inputName, value) => {
    if (inputName === 'CategoryName') {
      const selectedPtype = categorydata.find(item => item.label === value);
      const newCategoryName = selectedPtype ? selectedPtype.label : '';
      const newCategoryValue = selectedPtype ? selectedPtype.value : '';
      setSelectedCategoryCode([newCategoryValue]);
      const updatedEditedData = {
        ...editedData,
        CategoryCode: newCategoryValue,
        CategoryName: newCategoryName
      };
      setEditedData(updatedEditedData);
    } else if (inputName === 'ProductTypeName') {
      const selectedPtype = productypedata.find(item => item.label === value);
      const newProductName = selectedPtype ? selectedPtype.label : '';
      const newProductValue = selectedPtype ? selectedPtype.value : '';
      const updatedEditedData = {
        ...editedData,
        ProductTypeCode: newProductValue,
        ProductTypeName: newProductName
      };
      setEditedData(updatedEditedData);
    } else if (inputName === 'ColorName') {
      const selectedPtype = colordata.find(item => item.label === value);
      const newColorName = selectedPtype ? selectedPtype.label : '';
      const newColorValue = selectedPtype ? selectedPtype.value : '';
      const updatedEditedData = {
        ...editedData,
        ColorCode: newColorValue,
        ColorName: newColorName
      };
      setEditedData(updatedEditedData);
    } else if (inputName === 'FinishName') {
      const selectedPtype = finishdata.find(item => item.label === value);
      const newFinishName = selectedPtype ? selectedPtype.label : '';
      const newFinishValue = selectedPtype ? selectedPtype.value : '';
      const updatedEditedData = {
        ...editedData,
        FinishCode: newFinishValue,
        FinishName: newFinishName
      };
      setEditedData(updatedEditedData);
    } else if (inputName === 'BuyerName') {
      const selectedPtype = buyernamedata.find(item => item.label === value);
      const newProductName = selectedPtype ? selectedPtype.label : '';
      const updatedEditedData = {
        ...editedData,
        BuyerName: newProductName
      };
      setEditedData(updatedEditedData);
    } else if (inputName === 'HSNCode') {
      const selectedPtype = hsndata.find(item => item.label === value);
      const newProductName = selectedPtype ? selectedPtype.label : '';
      const updatedEditedData = {
        ...editedData,
        HSNCode: newProductName
      };
      setEditedData(updatedEditedData);
    } else if (inputName === 'MaterialCollection') {
      const mat = collectiondata.filter(item => {
        if (value.includes(item.label)) {
          return item;
        }
      });
      const selectedCollections = (mat || []).map((item, i) => ({
        ProductCode: '121',
        MatCollectionNm: (item.label && item.label.trim()) || '', // Perform a null check before calling trim()
        MatCollectionCode: (item.value && item.value.trim()) || ''
      }));
      const updatedEditedData = {
        ...editedData,
        MaterialCollection: selectedCollections
      };
      setEditedData(updatedEditedData);
    } else if (inputName === 'MaterialNm') {
      const mat = materialdata.filter(item => {
        if (value.includes(item.label)) {
          return item;
        }
      });
      const selectedMaterials = (mat || []).map((item, i) => ({
        ProductCode: '121',
        MaterialNm: (item.label && item.label.trim()) || '', // Perform a null check before calling trim()
        MaterialCode: (item.value && item.value.trim()) || ''
      }));
      const updatedEditedData = {
        ...editedData,
        ProductionDetail: selectedMaterials
      };
      setEditedData(updatedEditedData);
    } else if (inputName === 'SellingPriceCurrency') {
      // When currency is selected
      const selectedCurrency = curr.find(currency => currency.value === value);
      if (selectedCurrency) {
        // Set exchangerate in SellingPriceUnit+
        const newSellingPrice = data5.SellingPrice || 0;
        const newProductCost = newSellingPrice * selectedCurrency.exchangerate;
        setData5(prevData => ({
          ...prevData,
          SellingPriceCurrency: value,
          SellingPriceUnit: String(selectedCurrency.exchangerate),
          ProductCost: parseFloat(newProductCost.toFixed(2))
        }));
      }
    } else if (inputName === 'SellingPriceUnit' || inputName === 'SellingPrice') {
      const newSellingPriceUnit = inputName === 'SellingPriceUnit' ? value : data5.SellingPriceUnit;
      const newSellingPrice = inputName === 'SellingPrice' ? value : data5.SellingPrice;
      // Check for negative values for SellingPriceUnit and SellingPrice
      if (newSellingPriceUnit >= 0 && newSellingPrice >= 0) {
        // Calculate the new ProductCost
        // Calculate L, M, MX prices using costinghead percentages
        const newL = parseFloat((newSellingPrice * (1 + costinghead.L / 100)).toFixed(2));
        const newM = parseFloat((newSellingPrice * (1 + costinghead.M / 100)).toFixed(2));
        const newMX = parseFloat((newSellingPrice * (1 + costinghead.X / 100)).toFixed(2));
        let newProductCost = newSellingPriceUnit * newSellingPrice;
        newProductCost = parseFloat(newProductCost.toFixed(2));
        setData5(prevData => ({
          ...prevData,
          SellingPriceUnit: newSellingPriceUnit,
          SellingPrice: newSellingPrice,
          ProductCost: newProductCost,
          L: newL,
          M: newM,
          MX: newMX
        }));
      } else {
        // handleOpenne();
      }
    } else if (
      inputName === 'SizeUnit' ||
      inputName === 'Length' ||
      inputName === 'Width' ||
      inputName === 'Height'
    ) {
      // Extract values from the editedData state
      const { SizeUnit, Length, Width, Height } = editedData;

      // Convert value to string if it's an object (for InputPicker)
      const selectedValue = typeof value === 'object' ? value.value : value;

      // Convert Length, Width, and Height to numbers
      const numericLength = parseFloat(String(Length));
      const numericWidth = parseFloat(String(Width));
      const numericHeight = parseFloat(String(Height));

      // Compute cbm based on SizeUnit, Length, Width, and Height
      const cbmValue =
        String(SizeUnit) === 'cm'
          ? (numericLength * numericWidth * numericHeight) / 1000000
          : (numericLength * numericWidth * numericHeight) / 61023;
      setResult(cbmValue);
      setEditedData(prevState => ({
        ...prevState,
        [inputName]: selectedValue,
        cbm: cbmValue
      }));
    } else {
      setEditedData(prevState => ({
        ...prevState,
        [inputName]: value
      }));
    }
  };
  //** update costing for multiple product */
  const [isCostingUpdate, setIsCostingUpdate] = useState(false)
  const handleSaveCosting = async () => {
    setIsCostingUpdate(true)
    try {
      if (selectedItems.length === 0) {
        toaster.push(
          <Message showIcon type="error">
            Please select products
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      setIsLoadingupdate(true);
      setUpdatetask(selectedItems.length);

      for (const ProductId of selectedItems) {
        // Fetch existing product data
        const res = await fetch(`${ip}/api/products/${ProductId}?populate=*`);
        const productData = await res.json();
        const attributes = productData?.data?.attributes || {};

        // Only update costing fields
        const updatedData = {
          SellingPriceCurrency: data5.SellingPriceCurrency || attributes.SellingPriceCurrency,
          SellingPriceUnit: data5.SellingPriceUnit || attributes.SellingPriceUnit,
          SellingPrice: data5.SellingPrice || attributes.SellingPrice,
          ProductCost: data5.ProductCost || attributes.ProductCost
        };

        const formData = new FormData();
        formData.append('data', JSON.stringify(updatedData));

        const updateRes = await fetch(`${ip}/api/products/${ProductId}`, {
          method: 'PUT',
          body: formData
        });

        if (!updateRes.ok) {
          console.error(`Failed to update product ID ${ProductId}`);
        }
      }

      setIsLoadingupdate(false);
      setOpenCostingModal(false);
      setSelectedItems([]);
      setData5({
        CategoryCode: '',
        ProductTypeCode: '',
        ProductCode: '',
        ProductId: '',
        ProductName: '',
        Description: '',
        SizeUnit: 'inch',
        Length: 0,
        Width: 0,
        Height: 0,
        FinishCode: '',
        ColorCode: '',
        NetWeight: 0,
        GrossWeight: 0,
        HSNCode: '',
        SellingPriceCurrency: '',
        SellingPriceUnit: '',
        SellingPrice: 0,
        ProductCost: 0,
        SearchKeyword: '',
        MOQ: 0,
        ProductDesigner: '',
        MadeBy: '',
        CategoryName: '',
        ProductTypeName: '',
        cbm: 0,
        Shape: '',
        Season: '',
        P_Technique: '',
        FinishName: '',
        ColorName: '',
        BuyerName: '',
        BuyerSku: '',
        SizeRange: '',
        Product_Remark: '',
        Buyer_Remark: '',
        Variant: 'false',
        SetStatus: 'Single',
        Part: '1',
        Authorized: '',
        L: 0,
        M: 0,
        MX: 0,
        MaterialCollection: [
          {
            ProductCode: '',
            MatCollectionNm: '',
            MatCollectionCode: ''
          }
        ],
        ProductionDetail: [
          {
            ProductCode: '',
            MaterialNm: '',
            MaterialFinishNm: '',
            MatNetWeight: 0,
            MaterialCode: '',
            MaterialFinishCode: '',
            Component: '',
            Unit: 'inch',
            Length: 0,
            Width: 0,
            Height: 0,
            Depth: 0,
            Qty: 0,
            Remark: ''
          }
        ],
        CoverImage: null,
        MultipleImage: null,
        threeDview: null,
        Total_CBM: 0,
        Total_CFT: 0,
        TwentyFT: '',
        FortyFT: '',
        FortyHQ: '',
        Packaging: [
          {
            CartonType: 'master',
            ProductCode: '',
            Carton_Unit: 'inch',
            Carton_Length: 0,
            Carton_Width: 0,
            Carton_Thick: 0,
            Carton_CBM: 0,
            Carton_PCS: 1,
            Carton_CBMperpc: 0,
            Carton_GrsWt: 0
          }
        ],
        SetSizes: [
          {
            SizeUnit: 'inch',
            SetRate: 0,
            Length: 0,
            Width: 0,
            Height: 0,
            cbm: 0,
            Description: '',
            ColorName: '',
            ColorCode: '',
            FinishName: '',
            FinishCode: '',
            NetWt: 0,
            MatName: ''
          }
        ]
      })
      toaster.push(
        <Message showIcon type="success">
          {selectedItems.length} Products updated successfully
        </Message>,
        { placement: 'topEnd' }
      );
    } catch (error) {
      console.error('Error updating products:', error);
      setIsLoadingupdate(false);
    } finally {
      setIsCostingUpdate(false)
    }
  };

  //**end */

  const editProduct = async () => {
    try {
      if (selectedItems.length === 0) {
        toaster.push(
          <Message showIcon type="error">
            Please Select Products
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        setIsLoadingupdate(true);
        setUpdatetask(selectedItems.length);
        for (const ProductId of selectedItems) {
          const res = await fetch(`${ip}/api/products/${ProductId}?populate=*`);
          const productData = await res.json();
          const attributes = productData?.data?.attributes || {};
          const ProductCode = attributes.ProductCode || '';

          // Merge existing MaterialCollection with editedData (avoid data loss)
          const existingMaterialCollection = attributes.MaterialCollection || [];
          const editedMaterialCollection = editedData.MaterialCollection || [];

          const updatedMaterialCollection =
            editedMaterialCollection.length > 0
              ? editedMaterialCollection.map(item => ({
                ...item,
                ProductCode
              }))
              : existingMaterialCollection;

          // Merge existing ProductionDetail with editedData
          const existingProductionDetail = attributes.ProductionDetail || [];
          const editedProductionDetail = editedData.ProductionDetail || [];

          const updatedProductionDetail =
            editedProductionDetail.length > 0
              ? editedProductionDetail.map(item => ({
                ...item,
                ProductCode
              }))
              : existingProductionDetail;

          const formData = new FormData();
          formData.append(
            'data',
            JSON.stringify({
              CategoryName: editedData.CategoryName,
              CategoryCode: editedData.CategoryCode,
              ProductTypeName: editedData.ProductTypeName,
              ProductTypeCode: editedData.ProductTypeCode,
              ProductName: editedData.ProductName,
              Description: editedData.Description,
              SizeUnit: editedData.SizeUnit,
              Length: editedData.Length,
              Width: editedData.Width,
              Height: editedData.Height,
              cbm: editedData.cbm,
              SearchKeyword: editedData.SearchKeyword,
              MOQ: editedData.MOQ,
              ColorName: editedData.ColorName,
              ColorCode: editedData.ColorCode,
              FinishName: editedData.FinishName,
              FinishCode: editedData.FinishCode,
              NetWeight: editedData.NetWeight,
              GrossWeight: editedData.GrossWeight,
              MadeBy: editedData.MadeBy,
              ProductDesigner: editedData.ProductDesigner,
              BuyerName: editedData.BuyerName,
              BuyerSku: editedData.BuyerSku,
              HSNCode: editedData.HSNCode,
              Shape: editedData.Shape,
              Season: editedData.Season,
              P_Technique: editedData.P_Technique,
              MaterialCollection: updatedMaterialCollection,
              ProductionDetail: updatedProductionDetail
            })
          );
          const response = await fetch(`${ip}/api/products/${ProductId}`, {
            method: 'PUT',
            body: formData
          });
          if (response.ok) {
            // If the deletion is successful, log the result or perform any necessary actions
          } else {
            console.error(`Failed to Update fair product with ID ${ProductId}.`);
          }
        }
        setIsLoadingupdate(false);
        handleClosen();
        setSelectedItems([]);
        toaster.push(
          <Message showIcon type="success">
            {selectedItems.length} Products Saved Changes
          </Message>,
          { placement: 'topEnd' }
        );
      }
    } catch (error) {
      console.error('Error Updateing fair products:', error);
    }
  };

  const [selectall, setSelectall] = useState(false);
  const handleCheckboxChangeall = () => {
    const newSelectallState = !selectall;
    setSelectall(newSelectallState);
    setCategory(newSelectallState);
    setProductype(newSelectallState);
    setMoq(newSelectallState);
    setDescription(newSelectallState);
    setSearchKeyword(newSelectallState);
    setProductname(newSelectallState);
    setFinish(newSelectallState);
    setNetWeight(newSelectallState);
    setGrossweight(newSelectallState);
    setHsn(newSelectallState);
    setColor(newSelectallState);
    setProductDesigner(newSelectallState);
    setMadeby(newSelectallState);
    setBuyername(newSelectallState);
    setBuyersku(newSelectallState);
    setSizeUpdate(newSelectallState);
    setSeason(newSelectallState);
    setPtech(newSelectallState);
    setColl(newSelectallState);
    setShape(newSelectallState);
    setMat(newSelectallState);
  };

  useEffect(() => {
    if (
      category ||
      Productype ||
      moq ||
      description ||
      searchKeyword ||
      productname ||
      finish ||
      netWeight ||
      grossweight ||
      hsn ||
      color ||
      productDesigner ||
      madeby ||
      buyername ||
      buyersku ||
      sizeupdate ||
      season ||
      ptech ||
      coll ||
      shape ||
      mat
      // Add other checkbox states here similarly
    ) {
      setAtLeastOneChecked(true);
    } else {
      setAtLeastOneChecked(false);
    }
  }, [
    category,
    Productype,
    moq,
    description,
    searchKeyword,
    productname,
    finish,
    netWeight,
    grossweight,
    hsn,
    color,
    productDesigner,
    madeby,
    buyername,
    buyersku,
    sizeupdate,
    season,
    ptech,
    coll,
    shape,
    mat
  ]);
  const [collectiondata, setCollectiondata] = React.useState([]);
  const [isLoadingcoll, setIsLoadingcoll] = React.useState(false);
  useEffect(() => {
    fetchData3();
  }, []);
  const fetchData3 = async () => {
    if (isLoadingcoll) {
      return;
    }
    setIsLoadingcoll(true);
    try {
      const response = await fetch(`${ip}/api/mstmaterialcollections?&pagination[page]=1`);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/mstmaterialcollections?&pagination[page]=${page}`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.MatCollectionName,
          value: item.attributes.MatCollectionCode
        }));
        allData.push(...processedData);
      }
      setCollectiondata(allData);
      setIsLoadingcoll(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [materialdata, setMaterialdata] = useState([]);
  const [isLoadingmat, setIsLoadingmat] = useState(false);
  useEffect(() => {
    fetchData4();
  }, []);
  const fetchData4 = async () => {
    if (isLoadingmat) {
      return;
    }
    setIsLoadingmat(true);
    try {
      const response = await fetch(
        `${ip}/api/mstmaterials?&pagination[page]=1&filters[dis][$ne]=Discontinue&filters[Type][$eq]=mrmaterial&filters[Type][$eq]=cmaterial&filters[Type][$eq]=wmaterial&sort[0]=MaterialName`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/mstmaterials?&pagination[page]=${page}&filters[dis][$ne]=Discontinue&filters[Type][$eq]=mrmaterial&filters[Type][$eq]=cmaterial&filters[Type][$eq]=wmaterial&sort[0]=MaterialName`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.MaterialName,
          value: item.attributes.MaterialCode
        }));
        allData.push(...processedData);
      }
      setMaterialdata(allData);
      setIsLoadingmat(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const speaker = (
    <Popover title="Recent Task" style={{ width: 300 }}>
      {catetask > 0 || deltask > 0 || updatetask > 0 ? (
        <>
          {catetask > 0 && (
            <>
              <p>Moved of {catetask} Products Complete</p>
              <Divider className="divide" />
            </>
          )}
          {deltask > 0 && (
            <>
              <p>Deletion of {deltask} Products Complete</p>
              <Divider className="divide" />
            </>
          )}
          {updatetask > 0 && <p>Update of {updatetask} Products Complete</p>}
        </>
      ) : (
        <p>
          <b>No recent tasks</b>
        </p>
      )}
    </Popover>
  );
  const [openMenuBar, setOpenMenuBar] = useState(false);

  const cmToInch = value => (value / 2.54).toFixed(2);
  const inchToCm = value => (value * 2.54).toFixed(2);
  const [sizeUnit, setSizeUnit] = useState();
  const sizee = [
    { label: 'CM', value: 'cm' },
    { label: 'Inch', value: 'inch' }
  ];
  useFilter(
    selectedCategory,
    selectedProductType,
    selectedColor,
    selectedFinish,
    selectedAlias,
    setAliasdata,
    setFinishData,
    setColordata,
    setCategorydata,
    setProductypedata
  );
  const [reopen, setReOpen] = useState(false);
  const handleReClose = () => setReOpen(false);
  let printOrNot1 = 0;

  //** change costing for multiple product */
  const [openCostingModal, setOpenCostingModal] = useState(false)
  const [curr, setCurr] = useState([]);

  useEffect(() => {
    fetchDatacurr();
  }, []);

  const fetchDatacurr = async () => {
    try {
      const response = await fetch(`${ip}/api/currency-masters`);
      const json = await response.json();

      const currency = json.data.map(item => ({
        label: item.attributes.currencyname, // Setting label
        value: item.attributes.currencyname, // Setting value
        exchangerate: item.attributes.exchangerate
      }));
      setCurr(currency);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  //** update costing via csv */
  const [csvData, setCsvData] = useState([]);
  const [matchedProducts, setMatchedProducts] = useState([]);
  const [openCSVModal, setOpenCSVModal] = useState(false);
  // const downloadSampleFile = () => {
  //   const link = document.createElement("a");
  //   link.href = "../../../public/sampleCosting/CostingSample.xlsx"; // file inside public folder
  //   link.download = "CostingSample.xlsx";
  //   link.click();
  // };
  const downloadSampleFile = () => {
    const headers = ["Style No", "Currency", "Ex-Rate", "Sale Price"];

    // Convert to CSV format
    const csvContent = headers.join(",") + "\n";

    // Create Blob
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    // Create a downloadable link
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.href = url;
    link.download = "CostingSample.csv";
    link.click();

    // Cleanup
    URL.revokeObjectURL(url);
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = async (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        // Read first sheet
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // Convert to JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
        // console.log('Excel/CSV Data:', jsonData);

        // Fetch all products
        const json = await fetchAllProducts();
        if (!json?.data) return;

        // Map CSV by Style No for quick lookup
        const csvMap = {};
        jsonData.forEach(row => {
          if (row['Style No'] !== undefined && row['Style No'] !== null) {
            csvMap[row['Style No'].toString().trim()] = row;
          }
        });

        // Match products and include CSV fields
        const matchedProducts = json.data
          .filter(product => csvMap[product.attributes.ProductId?.toString().trim()])
          .map(product => {
            const csvRow = csvMap[product.attributes.ProductId.toString().trim()];
            return {
              ...product.attributes,
              id: product.id,
              image: product.CoverImage?.data?.attributes?.url
                ? `${globalIP}${product.CoverImage.data.attributes.url}`
                : null,
              Currency: csvRow?.Currency || product.attributes.SellingPriceCurrency,
              'Ex-Rate': csvRow?.['Ex-Rate'] || '',
              'Sale Price': csvRow?.['Sale Price'] || product.attributes.SellingPrice,
              'Sale Price (INR)': csvRow?.['Sale Price (INR)'] || product.attributes.ProductCost
            };
          });

        // console.log('Matched Products with CSV values:', matchedProducts);

        setMatchedProducts(matchedProducts);
        setOpenCSVModal(true);
      } catch (error) {
        console.error('Error reading CSV/Excel file:', error);
      }
    };

    reader.readAsArrayBuffer(file);
  };
  const updateProductsFromCSV = async () => {
    try {
      setIsLoadingupdate(true);

      for (const product of matchedProducts) {
        const res = await fetch(`${ip}/api/products/${product.id}?populate=*`);
        const productData = await res.json();
        const attributes = productData?.data?.attributes || {};
        const updatedData = {
          SellingPriceCurrency: String(product.Currency),
          SellingPriceUnit: String(product['Ex-Rate']),
          SellingPrice: String(product['Sale Price']),
          ProductCost: String(product['Sale Price (INR)']),
        };

        const formData = new FormData();
        formData.append('data', JSON.stringify(updatedData));

        await fetch(`${ip}/api/products/${product.id}`, {
          method: 'PUT',
          body: formData
        });
      }

      toaster.push(
        <Message showIcon type="success">
          {matchedProducts.length} Products updated successfully
        </Message>,
        { placement: 'topEnd' }
      );

      setOpenCSVModal(false);
      setMatchedProducts([]); // Clear after update
      setIsLoadingupdate(false);

    } catch (error) {
      console.error('Error updating products from CSV:', error);
      setIsLoadingupdate(false);
    }
  };

  const menu = (
    <Menu>
      <Menu.Item key="1" icon={<DownloadOutlined />} onClick={downloadSampleFile}>
        Download Costing Sample
      </Menu.Item>
      <Menu.Item key="2" icon={<UploadOutlined />} onClick={() => document.getElementById("fileInput").click()}>
        Import CSV for Costing
      </Menu.Item>
    </Menu>
  );

  //** manage product */
  const [csvRows, setCsvRows] = useState([]);             // File content (as rows)
  const [headerMapping, setHeaderMapping] = useState({}); // user-selected mapping
  const [openMapModal, setOpenMapModal] = useState(false); // mapping modal
  // Delete a row by index
  const deleteCsvRow = (index) => {
    setCsvRows(prev => prev.filter((_, i) => i !== index));
  };

  // Add a blank row (same length as header)
  const addCsvRow = () => {
    if (csvRows.length === 0) return;

    const emptyRow = new Array(csvRows[0].length).fill("");
    setCsvRows(prev => [...prev, emptyRow]);
  };
  // Toggle editing mode for a row
  const toggleEditRow = (key) => {
    setCsvRows(prev =>
      prev.map(row =>
        row.key === key ? { ...row, isEditing: !row.isEditing } : row
      )
    );
  };

  const generateHeaderList = (obj, prefix = "") => {
    let keys = [];

    for (let key in obj) {
      const val = obj[key];

      if (Array.isArray(val)) {
        // array itself
        keys.push(prefix + key);

        if (val.length > 0 && typeof val[0] === "object") {
          Object.keys(val[0]).forEach(inner =>
            keys.push(`${prefix}${key}.${inner}`)
          );
        }

      } else if (typeof val === "object" && val !== null) {
        keys.push(prefix + key);
        keys.push(...generateHeaderList(val, `${prefix}${key}.`));

      } else {
        keys.push(prefix + key);
      }
    }

    return keys;
  };

  const productHeaderOptions = generateHeaderList(data5);

  const handleUpdateProductFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      console.log("Raw file data loaded:", data);

      const workbook = XLSX.read(data, { type: "array" });
      console.log("Workbook loaded:", workbook);

      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      console.log("Sheet data:", sheet);

      // read sheet WITHOUT HEADERS
      let json = XLSX.utils.sheet_to_json(sheet, {
        header: 1,
        raw: false,        // convert dates automatically
        defval: ""         // default value for empty cells
      });
      console.log("Initial JSON from sheet:", json);

      // remove completely empty rows
      json = json.filter(row => row.some(cell => cell !== "" && cell !== null));
      console.log("After removing empty rows:", json);

      // convert any Excel date serials to readable format
      json = json.map(row =>
        row.map(cell => {
          if (cell instanceof Date) {
            const d = cell.getDate().toString().padStart(2, "0");
            const m = (cell.getMonth() + 1).toString().padStart(2, "0");
            const y = cell.getFullYear();
            return `${d}-${m}-${y}`;
          }
          if (typeof cell === "string") {
            return cell.replace(/[\r\n]+/g, "").trim(); // remove line breaks and trim spaces
          }
          return cell; // keep numbers as-is
        })
      );

      console.log("After formatting dates:", json);

      setCsvRows(
        json.map((row, idx) => ({
          key: idx,
          cells: row,
          isEditing: false,
        }))
      );
      setOpenMapModal(true); // open mapping modal
    };

    reader.readAsArrayBuffer(file);
  };
  const applyMappedUpdate = async () => {
    if (!Object.keys(headerMapping).length) {
      alert("Please map at least one column");
      return;
    }

    const mapped = [];

    csvRows.forEach(row => {
      const item = {};

      Object.entries(headerMapping).forEach(([colIndex, fieldName]) => {
        // Use row.cells instead of row itself
        item[fieldName] = row.cells[colIndex] ?? "";
      });

      mapped.push(item);
    });

    setMatchedProducts(mapped);
    await updateMappedProducts(mapped);
    setOpenMapModal(false);
  };

  // const applyMappedUpdate = async () => {
  //   if (!Object.keys(headerMapping).length) {
  //     alert("Please map at least one column");
  //     return;
  //   }

  //   const mapped = [];

  //   csvRows.forEach(row => {
  //     const item = {};

  //     Object.entries(headerMapping).forEach(([colIndex, fieldName]) => {
  //       item[fieldName] = row[colIndex];
  //     });

  //     mapped.push(item);
  //   });

  //   setMatchedProducts(mapped);
  //   await updateMappedProducts(mapped);
  //   setOpenMapModal(false);

  //   // FIXED — pass manually
  // };

  // const updateMappedProducts = async (products) => {
  //   try {
  //     setIsLoadingupdate(true);

  //     for (const csv of products) {
  //       const productId = csv.ProductId;
  //       if (!productId) continue;

  //       // STEP 1 — get product by ProductId
  //       const res = await fetch(
  //         `${ip}/api/products?filters[ProductId][$eq]=${productId}&populate=*`
  //       );
  //       const json = await res.json();

  //       if (!json.data || json.data.length === 0) continue;

  //       const prod = json.data[0];
  //       const dbId = prod.id;
  //       const existing = prod.attributes;

  //       // clone
  //       const updated = structuredClone(existing);

  //       // STEP 2 — apply simple nested fields
  //       Object.entries(csv).forEach(([key, value]) => {
  //         if (!key.startsWith("ProductionDetail.") &&
  //           !key.startsWith("MaterialCollection.") &&
  //           key !== "ProductId") {
  //           setNested(updated, key, value);
  //         }
  //       });

  //       // STEP 3 — handle ProductionDetail array
  //       if (Object.keys(csv).some(k => k.startsWith("ProductionDetail."))) {
  //         updated.ProductionDetail = updated.ProductionDetail || [{}];

  //         const row = updated.ProductionDetail[0];

  //         Object.entries(csv).forEach(([key, value]) => {
  //           if (key.startsWith("ProductionDetail.")) {
  //             const field = key.split(".")[1];
  //             row[field] = value;
  //           }
  //         });

  //         row.ProductCode = existing.ProductCode;
  //       }

  //       // STEP 4 — handle MaterialCollection array
  //       if (Object.keys(csv).some(k => k.startsWith("MaterialCollection."))) {
  //         updated.MaterialCollection = updated.MaterialCollection || [{}];

  //         const row = updated.MaterialCollection[0];

  //         Object.entries(csv).forEach(([key, value]) => {
  //           if (key.startsWith("MaterialCollection.")) {
  //             const field = key.split(".")[1];
  //             row[field] = value;
  //           }
  //         });

  //         row.ProductCode = existing.ProductCode;
  //       }

  //       // remove strapi props
  //       delete updated.createdAt;
  //       delete updated.updatedAt;
  //       delete updated.publishedAt;

  //       // STEP 5 — send FormData
  //       const formData = new FormData();
  //       formData.append("data", JSON.stringify(updated));

  //       await fetch(`${ip}/api/products/${dbId}`, {
  //         method: "PUT",
  //         body: formData
  //       });

  //       console.log("Updated product:", productId);
  //     }

  //     toaster.push(
  //       <Message showIcon type="success">
  //         Products updated successfully
  //       </Message>,
  //       { placement: "topCenter" }
  //     );

  //     setMatchedProducts([]);
  //     setOpenCSVModal(false);

  //   } catch (err) {
  //     console.error("Update error:", err);
  //   } finally {
  //     setIsLoadingupdate(false);
  //   }
  // };
  //**working */
  // const updateMappedProducts = async (products) => {
  //   try {
  //     setIsLoadingupdate(true);

  //     for (const csv of products) {
  //       const productId = csv.ProductId;
  //       if (!productId) continue;

  //       // 1️⃣ Fetch existing product
  //       const res = await fetch(`${ip}/api/products?filters[ProductId][$eq]=${productId}&populate=*`);
  //       const json = await res.json();
  //       if (!json.data || json.data.length === 0) continue;

  //       const prod = json.data[0];
  //       const dbId = prod.id;
  //       const existing = prod.attributes;

  //       // 2️⃣ Clone existing product
  //       const updated = structuredClone(existing);

  //       // 3️⃣ Update simple fields
  //       Object.entries(csv).forEach(([key, value]) => {
  //         if (!key.includes(".") && key !== "ProductId") {
  //           updated[key] = value;
  //         }
  //       });

  //       // 4️⃣ Helper to generate next ProductCode
  //       const generateNextProductCode = () => {
  //         const nextNum = existing.TotalProductsCount ? existing.TotalProductsCount + 1 : 1;
  //         return `PRD-${String(nextNum).padStart(3, "0")}`;
  //       };

  //       // 5️⃣ Update arrays (push new object instead of replacing)
  //       ["ProductionDetail", "MaterialCollection", "Packaging", "SetSizes"].forEach(arrayName => {
  //         const csvArrayKeys = Object.keys(csv).filter(k => k.startsWith(arrayName + "."));
  //         if (!csvArrayKeys.length) return;

  //         if (!Array.isArray(updated[arrayName])) updated[arrayName] = [];

  //         const newObj = {};

  //         csvArrayKeys.forEach(key => {
  //           const field = key.split(".")[1];
  //           newObj[field] = csv[key];
  //         });

  //         // Assign ProductCode for ProductionDetail and MaterialCollection
  //         if (arrayName === "ProductionDetail" || arrayName === "MaterialCollection") {
  //           newObj.ProductCode = generateNextProductCode();
  //         }

  //         // Push new object into the array
  //         updated[arrayName].push(newObj);
  //       });

  //       // 6️⃣ Preserve existing images
  //       updated.CoverImage = existing.CoverImage;
  //       updated.MultipleImage = existing.MultipleImage;
  //       updated.threeDview = existing.threeDview;

  //       // 7️⃣ Remove system fields
  //       delete updated.createdAt;
  //       delete updated.updatedAt;
  //       delete updated.publishedAt;

  //       // 8️⃣ Send update request
  //       await fetch(`${ip}/api/products/${dbId}`, {
  //         method: "PUT",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({ data: updated }),
  //       });

  //       console.log("Updated product:", productId);
  //     }

  //     toaster.push(
  //       <Message showIcon type="success">Products updated successfully</Message>,
  //       { placement: "topCenter" }
  //     );

  //     setMatchedProducts([]);
  //     setOpenCSVModal(false);

  //   } catch (err) {
  //     console.error("Update error:", err);
  //   } finally {
  //     setIsLoadingupdate(false);
  //   }
  // };

  // const updateMappedProducts = async (products) => {
  //   try {
  //     setIsLoadingupdate(true);

  //     // Group products by ProductId
  //     const grouped = products.reduce((acc, row) => {
  //       const pid = row.ProductId;
  //       if (!pid) return acc;
  //       if (!acc[pid]) acc[pid] = [];
  //       acc[pid].push(row);
  //       return acc;
  //     }, {});

  //     for (const productId of Object.keys(grouped)) {
  //       const csvRows = grouped[productId];

  //       // Fetch existing product (optional if you just need id)
  //       const res = await fetch(`${ip}/api/products?filters[ProductId][$eq]=${productId}&populate=*`);
  //       const json = await res.json();
  //       if (!json.data || json.data.length === 0) continue;

  //       const prod = json.data[0];
  //       const dbId = prod.id;

  //       // Prepare minimal update object
  //       const updateObj = {};

  //       // Helper to generate ProductCode for array items
  //       const generateNextProductCode = (index) => `PRD-${String(index + 1).padStart(3, "0")}`;

  //       // Arrays to update
  //       ["ProductionDetail", "MaterialCollection", "Packaging", "SetSizes"].forEach(arrayName => {
  //         const hasAnyData = csvRows.some(csv =>
  //           Object.keys(csv).some(k => k.startsWith(arrayName + "."))
  //         );
  //         if (!hasAnyData) return; // skip this array entirely
  //         updateObj[arrayName] = [];

  //         csvRows.forEach((csv, rowIndex) => {
  //           const csvArrayKeys = Object.keys(csv).filter(k => k.startsWith(arrayName + "."));
  //           if (!csvArrayKeys.length) return;

  //           const newObj = {};
  //           csvArrayKeys.forEach(key => {
  //             const field = key.split(".")[1];
  //             newObj[field] = csv[key];
  //           });

  //           // Add ProductCode for ProductionDetail / MaterialCollection
  //           if (arrayName === "ProductionDetail" || arrayName === "MaterialCollection") {
  //             newObj.ProductCode = generateNextProductCode(rowIndex);
  //           }

  //           updateObj[arrayName].push(newObj);
  //         });
  //       });

  //       // Include simple mapped fields (non-array)
  //       csvRows.forEach(csv => {
  //         Object.entries(csv).forEach(([key, value]) => {
  //           if (!key.includes(".") && key !== "ProductId") {
  //             updateObj[key] = value;
  //           }
  //         });
  //       });

  //       // Send PUT request with only mapped fields
  //       await fetch(`${ip}/api/products/${dbId}`, {
  //         method: "PUT",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({ data: updateObj })
  //       });

  //       console.log("Updated product:", productId);
  //     }

  //     toaster.push(
  //       <Message showIcon type="success">Products updated successfully</Message>,
  //       { placement: "topCenter" }
  //     );

  //     setMatchedProducts([]);
  //     setOpenCSVModal(false);

  //   } catch (err) {
  //     console.error("Update error:", err);
  //   } finally {
  //     setIsLoadingupdate(false);
  //   }
  // };


  const updateMappedProducts = async (products) => {
    try {
      setIsLoadingupdate(true);

      // Group products by ProductId
      const grouped = products.reduce((acc, row) => {
        const pid = row.ProductId;
        if (!pid) return acc;
        if (!acc[pid]) acc[pid] = [];
        acc[pid].push(row);
        return acc;
      }, {});

      for (const productId of Object.keys(grouped)) {
        const csvRows = grouped[productId];

        // Fetch existing product
        const res = await fetch(`${ip}/api/products?filters[ProductId][$eq]=${productId}&populate=*`);
        const json = await res.json();
        if (!json.data || json.data.length === 0) continue;

        const prod = json.data[0];
        const dbId = prod.id;
        const existing = prod.attributes;

        // Prepare minimal update object
        const updateObj = {};

        // Helper → ProductCode
        const generateNextProductCode = (index) =>
          `PRD-${String(index + 1).padStart(3, "0")}`;

        // Arrays to update
        ["ProductionDetail", "MaterialCollection", "Packaging", "SetSizes"].forEach(arrayName => {
          const hasAnyData = csvRows.some(csv =>
            Object.keys(csv).some(k => k.startsWith(arrayName + "."))
          );
          if (!hasAnyData) return;

          // --- FIX: Preserve existing valid objects only ---
          const existingArray = Array.isArray(existing[arrayName]) ? existing[arrayName] : [];
          const cleanedExisting = existingArray.filter(obj =>
            obj && Object.keys(obj).length > 0 &&
            Object.values(obj).some(val => val !== "" && val !== null)
          );

          // Start with cleaned existing objects
          updateObj[arrayName] = [...cleanedExisting];

          // Append new mapped CSV objects
          csvRows.forEach((csv, rowIndex) => {
            const csvArrayKeys = Object.keys(csv).filter(k => k.startsWith(arrayName + "."));
            if (!csvArrayKeys.length) return;

            const newObj = {};
            csvArrayKeys.forEach(key => {
              const field = key.split(".")[1];
              newObj[field] = csv[key];
            });

            if (arrayName === "ProductionDetail" || arrayName === "MaterialCollection") {
              newObj.ProductCode = generateNextProductCode(rowIndex);
            }

            updateObj[arrayName].push(newObj);
          });
        });

        // Simple non-array mapped fields
        csvRows.forEach(csv => {
          Object.entries(csv).forEach(([key, value]) => {
            if (!key.includes(".") && key !== "ProductId") {
              updateObj[key] = value;
            }
          });
        });

        // PUT request with mapped data only
        await fetch(`${ip}/api/products/${dbId}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ data: updateObj })
        });

        console.log("Updated product:", productId);
      }

      toaster.push(
        <Message showIcon type="success">Products updated successfully</Message>,
        { placement: "topCenter" }
      );

      setMatchedProducts([]);
      setOpenCSVModal(false);

    } catch (err) {
      console.error("Update error:", err);
    } finally {
      setIsLoadingupdate(false);
    }
  };

  return (
    <>
      <LoadingBar color="#3498ff" progress={progress} onLoaderFinished={() => setProgress(0)} />
      <Container className="main">
        <div
          style={{
            justifyContent: 'space-between',
            width: '-webkit-fill-available',
            position: 'fixed',
            height: '180px',
            background: '#fff',
            zIndex: 1
          }}
        >
          <Stack className="table-toolbar product-head" justifyContent="space-between">
            <Stack direction="column" alignItems="flex-start">
              <Stack direction="column" alignItems="flex-start" className="product-mgd-dlt">
                <Stack direction="row" alignItems="flex-start" spacing={170}>
                  <h3 className="title">Manage Product</h3>
                  <div onClick={() => setOpenMenuBar(!openMenuBar)}>
                    <MenuIcon className="burgerMenu1" />
                    {/* <CloseIcon className='burgerMenu1'/> */}
                  </div>
                </Stack>
                <Breadcrumb>
                  <Breadcrumb.Item href={`/${ugr}/dashboard`}>Home</Breadcrumb.Item>
                  <Breadcrumb.Item active>Manage Product</Breadcrumb.Item>
                </Breadcrumb>
              </Stack>
              <Stack spacing={5} className={openMenuBar ? 'product-item' : 'mange-search'}>
                <HeaderFilter
                  {...{
                    head,
                    label,
                    //data states
                    categorydata,
                    productypedata,
                    colordata,
                    proNamedata,
                    skudata,
                    buyernamedata,
                    finishdata,
                    aliasdata,
                    searchdata,
                    proDdata,
                    madedata,
                    hsndata,
                    // materialdata,
                    setCategorydata,
                    setIsLoadingc,
                    isLoadingc,
                    SetIsLoadingTableData,
                    setProgress,
                    setColordata,
                    isLoadingcolor,
                    setIsLoadingcolor,
                    setFinishData,
                    isLoadingfin,
                    setIsLoadingfin,
                    setHsndata,
                    isLoadinghsn,
                    setIsLoadinghsn,
                    // setMaterialdata, isLoadingmat, setIsLoadingmat,
                    //selectedstates
                    selectedCategory,
                    selectedProductType,
                    selectedColor,
                    selectedpron,
                    selectedsku,
                    selectedBuyer,
                    selectedFinish,
                    selectedAlias,
                    selectedSearch,
                    selectedpd,
                    selectedmade,
                    selectedhsn,
                    // selectedmaterial,
                    //onchangehandlers
                    selectedDateRange,
                    selectedUpdatedDateRange,
                    handleDatechange,
                    handleUpdatedDatechange,
                    handleCategoryChange,
                    handleProductTypeChange,
                    handleColorChange,
                    handleProNameChange,
                    handleSkuChange,
                    handleBuyerChange,
                    handleFinishChange,
                    handleAliasChange,
                    handleSearchChange,
                    handleProDChange,
                    handleMadeChange,
                    handleHSNChange,
                    // handleMaterialChange,
                    //onopenfunctions
                    fetchCategory,
                    fetchColors,
                    fetchFinishes,
                    fetchProductTypes,
                    fetchAlias,
                    fetchHsn,
                    fetchMaterials
                    //rendermenus
                    // renderMenu2,
                    // renderMenu5,
                    // renderMenu1,
                    // renderMenu,
                    // renderMenu3,
                    // renderMenu4
                  }}
                />
                <Button appearance="default" active onClick={() => setShowDrawer(true)}>
                  More Filter
                </Button>
                <div>
                  {auth === true && (
                    <SelectPicker
                      style={{ width: 120 }}
                      data={authstatus}
                      value={authst}
                      onChange={value => setAuthst(value)}
                      searchable={false}
                      cleanable={false}
                    />
                  )}
                </div>
                <div>
                  {(selectedCategory.length > 0 ||
                    selectedProductType.length > 0 ||
                    selectedColor.length > 0 ||
                    selectedFinish.length > 0 ||
                    selectedhsn.length > 0 ||
                    selectedBuyer.length > 0 ||
                    selectedSearch.length > 0 ||
                    selectedAlias.length > 0 ||
                    selectedpron.length > 0 ||
                    selectedpd.length > 0 ||
                    selectedmade.length > 0 ||
                    // searchQryBtn ||
                    selectedsku.length > 0) && (
                      <b style={{ marginLeft: '6px' }}>
                        Total Products: {data123?.length ?? 0}/{meta123?.pagination?.total ?? 0}
                      </b>
                    )}

                  {selectedCategory.length === 0 &&
                    selectedProductType.length === 0 &&
                    selectedColor.length === 0 &&
                    selectedFinish.length === 0 &&
                    selectedhsn.length === 0 &&
                    selectedBuyer.length === 0 &&
                    selectedSearch.length === 0 &&
                    selectedAlias.length === 0 &&
                    selectedpron.length === 0 &&
                    selectedpd.length === 0 &&
                    selectedmade.length === 0 &&
                    selectedsku.length === 0 &&
                    meta123 && (
                      <b>
                        Products: {data123.length}/{meta123.pagination.total}
                      </b>
                    )}
                </div>
              </Stack>
            </Stack>
            <Stack
              direction="column"
              alignItems="flex-end"
              spacing={10}
              className="mange-search market-search1 manage-prdt-search"
            >
              <Stack direction="row" spacing={5}>
                {catetask > 0 || deltask > 0 || updatetask > 0 ? (
                  <Whisper
                    preventOverflow
                    trigger="click"
                    controlId="control-id-container"
                    speaker={speaker}
                    placement="bottomEnd"
                  >
                    <p
                      style={{
                        backgroundColor: '#00bcd4',
                        padding: '6px',
                        borderRadius: '16px',
                        cursor: 'pointer',
                        color: 'white'
                      }}
                    >
                      Task History
                    </p>
                  </Whisper>
                ) : (
                  <></>
                )}

                {(user.PRDDelete === true || user.Category === 'Admin') && (
                  <IconButton icon={<Trash />} active onClick={() => setReOpen(true)} />
                )}
                <InputGroup inside>
                  <Input
                    placeholder="Search"
                    type="text"
                    value={searchQuery}
                    onChange={value => {
                      setSearchQuery(value);
                    }}
                  />
                  <InputGroup.Addon>
                    <SearchIcon />
                  </InputGroup.Addon>
                </InputGroup>
                <AntdDropdown overlay={menu} trigger={['click']}>
                  <Button style={{ height: "35px" }}>
                    Update Costing <DownOutlined />
                  </Button>
                </AntdDropdown>

                {/* <AntdBtn
                  style={{ height: "35px", marginLeft: 10 }}
                  icon={<DownloadOutlined />}
                  onClick={downloadSampleFile}
                >
                  Download Costing Sample
                </AntdBtn>

                <AntdBtn
                  style={{ height: "35px" }}
                  icon={<UploadOutlined />}
                  onClick={() => document.getElementById('fileInput').click()}
                >
                  Import CSV for Costing
                </AntdBtn> */}
                <input
                  type="file"
                  id="fileInput"
                  accept=".csv, .xls, .xlsx, .xlsm"
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    handleFileUpload(e);
                    e.target.value = null; // reset input so same file can be selected again
                  }}
                />
                {data1[0]?.attributes?.isBulkUpdateProduct && (
                  <>
                    <AntdBtn
                      style={{ height: "35px" }}
                      icon={<UploadOutlined />}
                      onClick={() => document.getElementById("genericCsvInput").click()}
                    >
                      Import CSV / Excel
                    </AntdBtn>

                    <input
                      type="file"
                      id="genericCsvInput"
                      accept=".csv, .xls, .xlsx, .xlsm"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        handleUpdateProductFileUpload(e);
                        e.target.value = null; // reset input for same file selection
                      }}
                    />
                  </>
                )}

                <Dropdown title="Bulk Action" active placement="bottomEnd">
                  {(user.PRDEdit === true || user.Category === 'Admin') && (
                    <>
                      <Dropdown.Item
                        icon={<ImportIcon />}
                        onClick={handleOpenm}
                        disabled={selectedItems.length === 0}
                      >
                        Change {label[0]?.attributes.Category}
                      </Dropdown.Item>
                      <Dropdown.Item
                        icon={<Tag />}
                        onClick={() => setOpenCostingModal(true)}
                        disabled={selectedItems.length === 0}
                      >
                        Change Costing
                      </Dropdown.Item>
                      <Dropdown.Item
                        icon={<EditIcon />}
                        onClick={handleOpene}
                        disabled={selectedItems.length === 0}
                      >
                        Edit Attributes
                      </Dropdown.Item>
                      <Link
                        to={{
                          pathname: `/${ugr}/modify`,
                          search: `?selectedItems=${selectedItems.join(',')}`
                        }}
                        className="link"
                      >
                        <Dropdown.Item
                          icon={<TableColumnIcon />}
                          disabled={selectedItems.length === 0}
                        >
                          Modify on Table
                        </Dropdown.Item>
                      </Link>
                    </>
                  )}
                  <Dropdown.Item
                    disabled={selectedItems.length === 0}
                    icon={<QrcodeIcon />}
                    onClick={() => setOpenq(true)}
                  >
                    Generate QR Code
                  </Dropdown.Item>
                  {(user.PRDDelete === true || user.Category === 'Admin') && (
                    <Dropdown.Item
                      icon={<TrashIcon />}
                      onClick={handleOpendelete}
                      disabled={selectedItems.length === 0}
                    >
                      Move to Trash
                    </Dropdown.Item>
                  )}
                </Dropdown>
              </Stack>
              <Stack>
                {selectedItems.length > 0 && (
                  <span
                    style={{
                      background: '#1677ff20',
                      padding: '2px 8px',
                      borderRadius: '12px',
                      fontSize: '12px',
                      border: '1px solid #1677ff40'
                    }}
                  >
                    {selectedItems.length} selected
                  </span>
                )}
                <Checkbox
                  indeterminate={
                    selectedItems.length > 0 &&
                    selectedItems.length < meta123?.pagination?.total
                  }
                  checked={
                    selectedItems.length > 0 &&
                    selectedItems.length === meta123?.pagination?.total
                  }
                  onChange={handleCheckAll}
                  className="manage-prdt-slt"
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>Select all</span>
                  </div>
                </Checkbox>

              </Stack>
            </Stack>
          </Stack>
          <Divider className="divide" />
        </div>
        <div className="row" style={{ marginTop: '168px' }}>
          <Panel className="manage-prdt-pnl">
            {/* <CheckboxGroup inline name="checkboxList" value={value} onChange={handleChange1} > */}
            <FlexboxGrid justify="start" style={{ textAlign: 'center', marginTop: "20px" }} className="datatbl-img">
              {data123.map(item => (
                <ProductCard
                  {...{
                    item,
                    label,
                    dataGrid: 6,
                    selectallvar: () => { }, // fucntion to select all variants visible only on showVariant=1
                    openVardata: () => { },
                    handleCheckboxChange,
                    selectedItems,
                    handleOpen,
                    productUpdate: false,
                    pid: () => { },
                    showCheckbox: 1, // null means no preference
                    showEditIcon: 0, // null means no preference
                    showVariant: null, // null means no preference
                    showQuickView: (user.PRDView === true || user.Category === "Admin") ? 1 : 3, // null means no preference
                    isMoving: isLoadingupdate
                  }}
                />
              ))}
            </FlexboxGrid>

            <Button ref={ref} style={{ visibility: 'hidden' }}></Button>
            {isLoading && <Loader center size="md" speed="fast" content="loading..." />}
            {isLoadingTableData && data123.length && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  height: '100px'
                }}
              >
                <Loader size="md" content="Loading..." style={{ color: 'red' }} />
              </div>
            )}
          </Panel>
          <Stack justifyContent="flex-end">
            <IconButton
              size="sm"
              icon={<SortUpIcon />}
              active
              onClick={scrollToTop}
              style={{
                position: 'fixed',
                top: '90%',
                right: 16,
                transform: 'translateY(-50%)',
                zIndex: 9999
              }}
            />
          </Stack>
        </div>
        <FilterDrawer
          {...{
            showDrawer,
            setShowDrawer,
            head,
            label,
            //data states
            categorydata,
            productypedata,
            colordata,
            proNamedata,
            skudata,
            buyernamedata,
            finishdata,
            aliasdata,
            searchdata,
            proDdata,
            madedata,
            hsndata,
            // materialdata,
            setCategorydata,
            setIsLoadingc,
            isLoadingc,
            SetIsLoadingTableData,
            setProgress,
            setColordata,
            isLoadingcolor,
            setIsLoadingcolor,
            setFinishData,
            isLoadingfin,
            setIsLoadingfin,
            setHsndata,
            isLoadinghsn,
            setIsLoadinghsn,
            // setMaterialdata, isLoadingmat, setIsLoadingmat,
            //selectedstates
            selectedCategory,
            selectedProductType,
            selectedColor,
            selectedpron,
            selectedsku,
            selectedBuyer,
            selectedFinish,
            selectedAlias,
            selectedSearch,
            selectedpd,
            selectedmade,
            selectedhsn,
            // selectedmaterial,
            //onchangehandlers
            selectedDateRange,
            selectedUpdatedDateRange,
            handleDatechange,
            handleUpdatedDatechange,
            handleCategoryChange,
            handleProductTypeChange,
            handleColorChange,
            handleProNameChange,
            handleSkuChange,
            handleBuyerChange,
            handleFinishChange,
            handleAliasChange,
            handleSearchChange,
            handleProDChange,
            handleMadeChange,
            handleHSNChange,
            // handleMaterialChange,
            //onopenfunctions
            fetchCategory,
            fetchColors,
            fetchFinishes,
            fetchProductTypes,
            fetchAlias,
            fetchHsn,
            fetchMaterials
            //rendermenus
            // renderMenu2,
            // renderMenu5,
            // renderMenu1,
            // renderMenu,
            // renderMenu3,
            // renderMenu4
          }}
        />
        <ProductQuickView
          {...{
            data11,
            label,
            handleClose,
            open,
            size,
            modeldata,
            handlePrevImage,
            handleNextImage,
            selectedImagePath,
            setSelectedImagePath,
            sizeshow,
            unitOptions,
            selectedUnit,
            handleSizeChange,
            convertDimensions,
            finShow,
            attributesName
          }}
        />
        <Modal open={openm} onClose={handleClosem} >
          <Modal.Header>
            <Modal.Title>
              <b>
                Change {label[0]?.attributes.Category} of {selectedItems.length} Products
              </b>
            </Modal.Title>
            <Modal.Title>
              <p style={{ marginTop: '5px', fontSize: '13px' }}>
                Selected products will be moved to the new {label[0]?.attributes.Category}
              </p>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormControlLabel>{label[0]?.attributes.Category}</FormControlLabel>
            <SelectPicker
              data={categorydata}
              onChange={value => {
                const selected = categorydata.find(item => item.value === value) || null;
                setSelectedCategorychange(selected);
                setSelectedCategoryCode([selected.value]);
              }}
              block
              menuStyle={{ width: 300 }}
              style={{ marginBottom: '10px' }}
            />
            <FormControlLabel>{label[0]?.attributes.ProductType}</FormControlLabel>
            <SelectPicker
              data={productypedata.filter(
                p => p.category === selectedCategoryCode[0]
              )}
              onChange={value => {
                const selected = productypedata.find(item => item.value === value) || null;
                setSelectedProductchange(selected);
              }}
              block
              menuStyle={{ width: 300 }}
            />
            {selectedCategorychange === null ? (
              <></>
            ) : (
              <Panel bordered style={{ marginTop: '6px', backgroundColor: '#f3f3f3' }}>
                <Stack direction="column" alignItems="flex-start">
                  <FormControlLabel>Are You Sure To Change</FormControlLabel>
                  <Checkbox
                    checked={isRobotChecked}
                    onChange={() => setIsRobotChecked(!isRobotChecked)}
                  >
                    I'm not a robot
                  </Checkbox>
                </Stack>
              </Panel>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClosem} appearance="subtle" active>
              Cancel
            </Button>
            <Button
              onClick={updatecategoryProduct}
              appearance="primary"
              color="cyan"
              loading={isLoadingupdate}
              disabled={!isRobotChecked}
            >
              Move
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal open={opene} onClose={handleClosee} >
          <Modal.Header>
            <Modal.Title>
              <b>Select Attributes You Want to Edit</b>
            </Modal.Title>
            <Modal.Title>
              <p style={{ marginTop: '5px', fontSize: '13px' }}>
                These values will be updated on selected products
              </p>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Checkbox checked={selectall} onChange={handleCheckboxChangeall}>
              Select all Attributes
            </Checkbox>
            <Divider className="divide" />
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={category} onChange={handlecategoryCheckbox}>
                  {label[0]?.attributes.Category}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={Productype} onChange={handlesubCategoryCheckbox}>
                  {label[0]?.attributes.ProductType}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={moq} onChange={handlemoqCheckbox}>
                  {label[0]?.attributes.MOQ}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={description} onChange={handledescriptionCheckbox}>
                  {label[0]?.attributes.Description}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={searchKeyword} onChange={handlesearchKeywordCheckbox}>
                  {label[0]?.attributes.searchKeyword}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={color} onChange={handlecolorCheckbox}>
                  {label[0]?.attributes.color}
                </Checkbox>
              </FlexboxGrid.Item>
              {!sizeshow ? (
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Checkbox checked={sizeupdate} onChange={handlesizeCheckbox}>
                    {label[0]?.attributes.Sizeunit}
                  </Checkbox>
                </FlexboxGrid.Item>
              ) : (
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Checkbox checked={sizeRange} onChange={handleSrangeCheckbox}>
                    {label[0]?.attributes.SizeRange}
                  </Checkbox>
                </FlexboxGrid.Item>
              )}
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productname} onChange={handleproductionTimeCheckbox}>
                  {label[0]?.attributes.ProductName}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={finish} onChange={handleremarksCheckbox}>
                  {label[0]?.attributes.finish}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={netWeight} onChange={handlesamplingTimeCheckbox}>
                  {label[0]?.attributes.NetWgt}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={grossweight} onChange={handleproductionTechCheckbox}>
                  {label[0]?.attributes.GrossWgt}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={hsn} onChange={handlepriceFromeVendorCheckbox}>
                  {label[0]?.attributes.HSN}
                </Checkbox>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productDesigner} onChange={handleexclusiveForCheckbox}>
                  {label[0]?.attributes.ProductDesigner}
                </Checkbox>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={madeby} onChange={handleshapeCheckbox}>
                  {label[0]?.attributes.MadeBy}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={buyername} onChange={handlevendornameCheckbox}>
                  {label[0]?.attributes.BuyerName}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={buyersku} onChange={handlethemeCheckbox}>
                  {label[0]?.attributes.BuyerSku}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={shape} onChange={handleShapeCheckbox}>
                  {label[0]?.attributes.Shape}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={season} onChange={handleSeasonCheckbox}>
                  {label[0]?.attributes.Season}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={ptech} onChange={handlePtechCheckbox}>
                  {label[0]?.attributes.P_Technique}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={coll} onChange={handleCollectionCheckbox}>
                  {label[0]?.attributes.Collection}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={mat} onChange={handleCollectionMaterials}>
                  {label[0]?.attributes.MaterialName}
                </Checkbox>
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClosee} appearance="subtle" active>
              Cancel
            </Button>
            <Button
              onClick={handleCloseecondition}
              appearance="primary"
              color="cyan"
              disabled={!atLeastOneChecked}
            >
              Next
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal open={openn} onClose={handleClosen} >
          <Modal.Header>
            <Modal.Title>
              <b>Edit selected attributes for products</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FlexboxGrid justify="space-around">
              {category && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.Category}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <SelectPicker
                      data={categorydata}
                      value={editedData.CategoryName}
                      onChange={value => {
                        handleInputChange('CategoryName', value);
                      }}
                      labelKey="label"
                      valueKey="label"
                      block
                      menuStyle={{ width: 300 }}
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {Productype && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.ProductType}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <SelectPicker
                      data={productypedata.filter(
                        p => p.category === editedData.CategoryCode
                      )}
                      value={editedData.ProductTypeName}
                      onChange={value => {
                        handleInputChange('ProductTypeName', value);
                      }}
                      labelKey="label"
                      valueKey="label"
                      block
                      menuStyle={{ width: 300 }}
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {productname && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.ProductName}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <Input
                      value={editedData.ProductName as string}
                      onChange={value => handleInputChange('ProductName', value)}
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {moq && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.MOQ}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <Input
                      value={editedData.MOQ as string}
                      onChange={value => handleInputChange('MOQ', value)}
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {description && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.Description}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <Input
                      value={editedData.Description as string}
                      onChange={value => handleInputChange('Description', value)}
                    />
                  </FlexboxGrid.Item>
                </>
              )}

              {sizeupdate && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                    <FormControlLabel>{label[0]?.attributes.Sizeunit}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={4} style={{ marginBottom: '5px' }}>
                    <InputPicker
                      data={siii}
                      id="SizeUnit"
                      name="SizeUnit"
                      value={editedData.SizeUnit}
                      onChange={value => handleInputChange('SizeUnit', value)}
                    />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={4} style={{ marginBottom: '5px' }}>
                    <Input
                      placeholder="Length"
                      value={editedData.Length as string}
                      onChange={value => handleInputChange('Length', value)}
                    />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={4} style={{ marginBottom: '5px' }}>
                    <Input
                      placeholder="Width"
                      value={editedData.Width as string}
                      onChange={value => handleInputChange('Width', value)}
                    />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={4} style={{ marginBottom: '5px' }}>
                    <Input
                      placeholder="Height"
                      value={editedData.Height as string}
                      onChange={value => handleInputChange('Height', value)}
                    />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={4} style={{ marginBottom: '5px' }}>
                    <Input placeholder="cbm" value={result} />
                  </FlexboxGrid.Item>
                </>
              )}
              {sizeRange && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.SizeRange}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <Input
                      value={editedData.SizeRange as string}
                      onChange={value => handleInputChange('SizeRange', value)}
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {searchKeyword && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.searchKeyword}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <Input
                      value={editedData.searchKeyword as string}
                      onChange={value => handleInputChange('searchKeyword', value)}
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {color && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.color}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <SelectPicker
                      data={colordata}
                      value={editedData.ColorName}
                      onChange={value => {
                        handleInputChange('ColorName', value);
                      }}
                      labelKey="label"
                      valueKey="label"
                      block
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {finish && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.finish}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <SelectPicker
                      data={finishdata}
                      value={editedData.FinishName}
                      onChange={value => {
                        handleInputChange('FinishName', value);
                      }}
                      labelKey="label"
                      valueKey="label"
                      block
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {netWeight && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.NetWgt}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <Input
                      value={editedData.NetWeight as string}
                      onChange={value => handleInputChange('NetWeight', value)}
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {grossweight && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.GrossWgt}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <Input
                      value={editedData.GrossWeight as string}
                      onChange={value => handleInputChange('GrossWeight', value)}
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {productDesigner && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.ProductDesigner}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <Input
                      value={editedData.ProductDesigner as string}
                      onChange={value => handleInputChange('ProductDesigner', value)}
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {madeby && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.MadeBy}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <Input
                      value={editedData.MadeBy as string}
                      onChange={value => handleInputChange('MadeBy', value)}
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {buyername && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.BuyerName}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <SelectPicker
                      data={buyernamedata}
                      value={editedData.BuyerName}
                      onChange={value => {
                        handleInputChange('BuyerName', value);
                      }}
                      labelKey="label"
                      valueKey="label"
                      block
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {buyersku && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.BuyerSku}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <Input
                      value={editedData.BuyerSku as string}
                      onChange={value => handleInputChange('BuyerSku', value)}
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {hsn && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.HSN}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <SelectPicker
                      data={hsndata}
                      value={editedData.HSNCode}
                      onChange={value => {
                        handleInputChange('HSNCode', value);
                      }}
                      labelKey="label"
                      valueKey="label"
                      block
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {shape && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.Shape}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <Input
                      value={editedData.Shape as string}
                      onChange={value => handleInputChange('Shape', value)}
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {season && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.Season}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <Input
                      value={editedData.Season as string}
                      onChange={value => handleInputChange('Season', value)}
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {ptech && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.P_Technique}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <Input
                      value={editedData.P_Technique as string}
                      onChange={value => handleInputChange('P_Technique', value)}
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {coll && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.Collection}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <CheckPicker
                      data={collectiondata}
                      id="MaterialCollection"
                      name="MaterialCollection"
                      value={editedData?.MaterialCollection?.map(
                        collection => collection.MatCollectionNm
                      )}
                      onChange={value => handleInputChange('MaterialCollection', value)}
                      placeholder="Select Collection"
                      labelKey="label"
                      valueKey="label"
                      placement="autoVerticalStart"
                      block
                      onOpen={fetchData3}
                    />
                  </FlexboxGrid.Item>
                </>
              )}
              {mat && (
                <>
                  <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                    <FormControlLabel>{label[0]?.attributes.MaterialName}</FormControlLabel>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={14} style={{ marginBottom: '5px' }}>
                    <CheckPicker
                      data={materialdata}
                      id="MaterialNm"
                      name="MaterialNm"
                      value={editedData?.ProductionDetail?.map(mat => mat.MaterialNm)}
                      onChange={value => handleInputChange('MaterialNm', value)}
                      placeholder="Select Material"
                      labelKey="label"
                      valueKey="label"
                      placement="autoVerticalStart"
                      block
                      onOpen={fetchData4}
                    />
                  </FlexboxGrid.Item>
                </>
              )}
            </FlexboxGrid>
            <Panel bordered style={{ marginTop: '6px', backgroundColor: '#f3f3f3' }}>
              <Stack direction="column" alignItems="flex-start">
                <FormControlLabel>Are You Sure To Change</FormControlLabel>
                <Checkbox
                  checked={isRobotChecked1}
                  onChange={() => setIsRobotChecked1(!isRobotChecked1)}
                >
                  I'm not a robot
                </Checkbox>
              </Stack>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClosen} appearance="subtle" active>
              Cancel
            </Button>
            <Button
              onClick={editProduct}
              appearance="primary"
              color="cyan"
              disabled={!isRobotChecked1}
              loading={isLoadingupdate}
            >
              Save
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal open={opendelete} onClose={handleClosedelete}>
          <Modal.Header>
            <Modal.Title>
              <b>Trash {selectedItems.length} Products</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel bordered style={{ marginTop: '6px', backgroundColor: '#f3f3f3' }}>
              <Stack direction="column" alignItems="flex-start">
                <FormControlLabel>
                  These Product Will be Move in Trash. Are you sure you want to Continue?
                </FormControlLabel>
                <Checkbox
                  checked={isRobotChecked2}
                  onChange={() => setIsRobotChecked2(!isRobotChecked2)}
                >
                  I'm not a robot
                </Checkbox>
              </Stack>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClosedelete} appearance="subtle" active>
              Cancel
            </Button>
            <Button
              onClick={deleteProduct}
              appearance="primary"
              disabled={!isRobotChecked2}
              color="cyan"
              loading={loadelete}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal size="md" open={openq} onClose={() => setOpenq(false)}>
          <Modal.Header><strong>Print Formats</strong></Modal.Header>
          <Modal.Body>
            <FlexboxGrid justify="space-around">
              <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{ marginBottom: '5px' }}>
                <Button
                  block
                  style={{ height: '18vh', objectFit: 'contain' }}
                  onClick={() => handleDownloadQR4(maindata, data1)}
                >
                  <img src={s2} style={{ height: '100%', objectFit: 'contain' }} />
                </Button>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button
                  block
                  style={{ height: '18vh', objectFit: 'contain' }}
                  onClick={() => handleDownloadQR5(maindata, data1)}
                >
                  <img src={s3} style={{ height: '100%', objectFit: 'contain' }} />
                </Button>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button
                  block
                  style={{ height: '18vh', objectFit: 'contain' }}
                  onClick={() => handleDownloadQR6(maindata, printOrNot1, data1)}
                >
                  <img src={s4} style={{ height: '100%', objectFit: 'contain' }} />
                </Button>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button
                  block
                  style={{ height: '18vh', objectFit: 'contain' }}
                  onClick={() => handleDownloadQR7(maindata, printOrNot1, data1)}
                >
                  <img src={s4} style={{ height: '100%', objectFit: 'contain' }} />
                </Button>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button
                  block
                  style={{ height: '18vh', objectFit: 'contain' }}
                  onClick={() => handleDownloadQR8(maindata, printOrNot1, data1)}
                >
                  <img src={s4} style={{ height: '100%', objectFit: 'contain' }} />
                </Button>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button
                  block
                  style={{ height: '18vh', objectFit: 'contain' }}
                  onClick={() => handleDownloadQR9(maindata, printOrNot1, data1)}
                >
                  <img src={s4} style={{ height: '100%', objectFit: 'contain' }} />
                </Button>
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={submitwithqr} appearance="primary" color="cyan">
              Done
            </Button>
          </Modal.Footer>
        </Modal>

        <Footer />
      </Container>
      <Modal
        open={openCostingModal}
        onClose={() => setOpenCostingModal(false)}
        size="lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>Change Costing</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FlexboxGrid justify="space-around" style={{ marginBottom: '20px' }}>
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <Form.Group >
                <Form.ControlLabel>{label[0]?.attributes?.Currency}</Form.ControlLabel>
                <div id="custom-container" style={{ position: 'relative' }}>
                  <SelectPicker
                    data={curr}
                    cleanable={false}
                    id="SellingPriceCurrency"
                    name="SellingPriceCurrency"
                    value={data5?.SellingPriceCurrency || ''}
                    onChange={(value) => handleInputChange('SellingPriceCurrency', value, 0)}
                    block
                    onOpen={fetchDatacurr}
                  />
                </div>
              </Form.Group>
            </FlexboxGrid.Item>

            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <Form.Group >
                <Form.ControlLabel>{label[0]?.attributes?.CurRate}</Form.ControlLabel>
                <Input
                  id="SellingPriceUnit"
                  name="SellingPriceUnit"
                  value={data5?.SellingPriceUnit || ''}
                  onChange={(value) => handleInputChange('SellingPriceUnit', value, 0)}
                  readOnly
                />
              </Form.Group>
            </FlexboxGrid.Item>

            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <Form.Group >
                <Form.ControlLabel>{label[0]?.attributes?.SalePrice}</Form.ControlLabel>
                <InputNumber
                  step={null}
                  style={{ width: '100%' }}
                  id="SellingPrice"
                  name="SellingPrice"
                  value={data5?.SellingPrice || 0}
                  onChange={(value) => handleInputChange('SellingPrice', value, 0)}
                />
              </Form.Group>
            </FlexboxGrid.Item>

            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <Form.Group >
                <Form.ControlLabel>{label[0]?.attributes?.SalePriceINR}</Form.ControlLabel>
                <InputNumber
                  readOnly
                  style={{ width: '100%' }}
                  id="ProductCost"
                  name="ProductCost"
                  value={data5?.ProductCost || 0}
                  onChange={(value) => handleInputChange('ProductCost', value, 0)}
                />
              </Form.Group>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setOpenCostingModal(false)} appearance="subtle">
            Cancel
          </Button>
          <Button onClick={handleSaveCosting} appearance="primary" loading={isCostingUpdate} disabled={isCostingUpdate}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        open={openCSVModal}
        onClose={() => {
          setOpenCSVModal(false);
          setMatchedProducts([]);
        }}
        size="lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>Update Costing from CSV</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #ccc' }}>
                <th style={{ padding: '8px', textAlign: 'center' }}>Image</th>
                <th style={{ padding: '8px' }}>Product Name</th>
                <th style={{ padding: '8px' }}>Product ID</th>
                <th style={{ padding: '8px' }}>Currency</th>
                <th style={{ padding: '8px' }}>Ex-Rate</th>
                <th style={{ padding: '8px' }}>Sale Price</th>
                <th style={{ padding: '8px' }}>Sale Price (INR)</th>
              </tr>
            </thead>
            <tbody>
              {matchedProducts.map((product, index) => (
                <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    {product.CoverImage ? (
                      <img
                        src={
                          `${globalIP}${product?.CoverImage?.data?.attributes?.url}`
                        }
                        alt={product.ProductName}
                        style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '4px' }}
                      />
                    ) : (
                      <div
                        style={{
                          width: '60px',
                          height: '60px',
                          backgroundColor: '#ddd',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '4px',
                          fontSize: '12px'
                        }}
                      >
                        No Image
                      </div>
                    )}
                  </td>
                  <td style={{ padding: '8px' }}>
                    <Input value={product.ProductName} disabled />
                  </td>
                  <td style={{ padding: '8px' }}>
                    <Input value={product.ProductId} disabled />
                  </td>
                  <td style={{ padding: '8px' }}>
                    <Input value={product.Currency || ''} disabled />
                  </td>
                  <td style={{ padding: '8px' }}>
                    <Input value={product['Ex-Rate'] || ''} disabled />
                  </td>
                  <td style={{ padding: '8px' }}>
                    <InputNumber value={product['Sale Price'] || 0} disabled style={{ width: '100%' }} />
                  </td>
                  <td style={{ padding: '8px' }}>
                    <InputNumber
                      value={
                        parseFloat(
                          ((product['Sale Price'] || 0) * (product['Ex-Rate'] || 0)).toFixed(3)
                        )
                      }
                      disabled style={{ width: '100%' }} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setOpenCSVModal(false);
              setMatchedProducts([]);
            }}
            appearance="subtle"
          >
            Cancel
          </Button>
          <Button onClick={updateProductsFromCSV} appearance="primary">
            Update Products
          </Button>
        </Modal.Footer>
      </Modal>

      {/* mapping value modal */}
      <AntdModal
        open={openMapModal}
        onCancel={() => {
          setOpenMapModal(false);
          setHeaderMapping({});
        }}
        footer={null}
        width="90%"

        centered
        title="Map Uploaded File Columns to Product Fields"
        bodyStyle={{ padding: 0 }} // remove extra padding for table
      >
        {csvRows.length === 0 ? (
          <p style={{ padding: 16 }}>No data found in file</p>
        ) : (
          <Table
            dataSource={csvRows.map((row, idx) => ({ key: idx, row }))}
            pagination={false}
            bordered
            scroll={{ x: "max-content", y: 400 }}
            style={{ tableLayout: "fixed" }}
            columns={[
              ...csvRows[0].cells.map((_, colIndex) => ({
                title: (
                  <Select
                    placeholder="Select Product Field"
                    style={{ width: "100%" }}
                    showSearch
                    optionLabelProp="label"
                    dropdownMatchSelectWidth={false} // allow dropdown to expand independently
                    onChange={(value) =>
                      setHeaderMapping((prev) => ({ ...prev, [colIndex]: value }))
                    }
                  >
                    {productHeaderOptions.map((field) => (
                      <Select.Option key={field} value={field}>
                        {field}
                      </Select.Option>
                    ))}
                  </Select>
                ),
                dataIndex: colIndex,
                key: colIndex,
                width: 300,
                ellipsis: true, // automatically truncate long content
                render: (_, record) => {
                  const row = csvRows[record.key];
                  return row.isEditing ? (
                    <AntDInput
                      value={row.cells[colIndex]}
                      onChange={(e) => {
                        const newRows = [...csvRows];
                        newRows[record.key].cells[colIndex] = e.target.value;
                        setCsvRows(newRows);
                      }}
                    />
                  ) : (
                    row.cells[colIndex]
                  );
                },
              })),

              // Actions column
              {
                title: "Actions",
                key: "actions",
                fixed: "right",
                width: 120,
                render: (_, record) => (
                  <Space>
                    <AntdBtn
                      size="small"
                      onClick={() => toggleEditRow(record.key)}
                    >
                      {csvRows[record.key].isEditing ? "Save" : "Edit"}
                    </AntdBtn>
                    <AntdBtn
                      danger
                      size="small"
                      onClick={() =>
                        setCsvRows(prev => prev.filter(r => r.key !== record.key))
                      }
                    >
                      Delete
                    </AntdBtn>
                  </Space>
                ),
              },
            ]}

          />

        )}

        {/* Footer fixed below table */}
        <div
          style={{
            marginTop: 8,
            textAlign: "right",
            padding: 8,
            borderTop: "1px solid #f0f0f0",
            background: "#fff",
            position: "sticky",
            bottom: 0,
            zIndex: 10,
          }}
        >
          <div style={{ marginTop: 8, marginBottom: 8 }}>
            <AntdBtn
              type="dashed"
              style={{ marginBottom: 8 }}
              onClick={() => {
                if (!csvRows.length) return;
                const emptyRow = new Array(csvRows[0].cells.length).fill("");
                setCsvRows(prev => [
                  ...prev,
                  { key: prev.length, cells: emptyRow, isEditing: true },
                ]);
              }}
            >
              + Add Row
            </AntdBtn>

          </div>

          <AntdBtn
            style={{ marginRight: 8 }}
            onClick={() => {
              setOpenMapModal(false);
              setHeaderMapping({});
            }}
          >
            Cancel
          </AntdBtn>

          <AntdBtn type="primary" onClick={applyMappedUpdate}>
            Apply Mapping & Update
          </AntdBtn>
        </div>
      </AntdModal>


      <RecyleProduct
        reopen={reopen}
        handleReClose={handleReClose}
        data={data}
        fetchDatat={fetchDatat}
        tableMeta={tableMeta}
        page={page}
        setPage={setPage}
        handleChangeLimit={handleChangeLimit}
        searchQuery1={searchQuery1}
        setSearchQuery1={setSearchQuery1}
        fetchData={fetchData}
      />
    </>
  );
};
export default ManageProduct;
